import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { FormBuilder, FormControl, Validators, FormGroup, FormArray, FormGroupDirective, AbstractControl, ValidationErrors, NgForm } from '@angular/forms';
import { CustomValidator } from 'src/app/shared/services/custom-validator.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';

import { FormValidatorService } from 'src/app/shared/form_Validation/form-validator.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/services/auth-service.service';
import { startWith, map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { RegisterBusinessModelDashboradComponent } from 'src/app/dashboard/shared/popups/register-business-model-dashborad/register-business-model-dashborad.component';
import { Observable, Subscription } from 'rxjs';
import { lengths } from 'src/app/shared/DataLengths';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TermsAndConditionComponent } from 'src/app/shared/terms-and-condition/terms-and-condition.component';
import { ConfirmComponent } from 'src/app/dashboard/shared/popups/confirm/confirm.component';
import { PasswordWarningComponent } from 'src/app/shared/password-warning/password-warning.component';
import { HistoryLabComponent } from 'src/app/shared/history-lab/history-lab.component';
import { UniversalAppComponent } from 'src/app/dashboard/universal-app/universal-app.component';
import { EditUserDashboardComponent } from 'src/app/shared/popup/edit-user-dashboard/edit-user-dashboard.component';
import { SelectionModel } from '@angular/cdk/collections';
import { AddNewFileComponent } from 'src/app/dashboard/shared/popups/add-new-file/add-new-file.component';
import { AddNewFolderComponent } from 'src/app/dashboard/shared/popups/add-new-folder/add-new-folder.component';
import { ShareDocComponent } from 'src/app/dashboard/shared/popups/share-doc/share-doc.component';
import { DeleteVerificationComponent } from 'src/app/dashboard/shared/popups/delete-verification/delete-verification.component';
import { environment_state } from 'src/app/config';
import { SharingGroupComponent } from 'src/app/dashboard/shared/popups/sharing-group/sharing-group.component';
import { AddBusinessComponent } from 'src/app/dashboard/shared/popups/add-business/add-business.component';
import { EditDocComponent } from 'src/app/dashboard/shared/popups/edit-doc/edit-doc.component';
import { EditFolderComponent } from 'src/app/dashboard/shared/popups/edit-folder/edit-folder.component';
import { MoveDocComponent } from 'src/app/dashboard/shared/popups/move-doc/move-doc.component';
import { AddMultipleDocsComponent } from 'src/app/dashboard/shared/popups/add-multiple-docs/add-multiple-docs.component';
import { FileHistoryComponent } from 'src/app/dashboard/shared/popups/file-history/file-history.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FilterComponent } from 'src/app/dashboard/shared/popups/filter/filter.component';
import { MatTabGroup } from '@angular/material/tabs';
import { TaskManagementComponent } from 'src/app/dashboard/shared/popups/task-management/task-management.component';
import { VerificationPopupComponent } from '../shared/popups/verification-popup/verification-popup.component';

class CrossFieldErrorMatcherAc implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control.dirty && form.hasError('AcnoDoNotMatch');
  }
}
class CrossFieldErrorMatcherRouting implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control.dirty && form.hasError('routingNoDoNotMatch');
  }
}   
@Component({
  selector: 'app-businesses',
  templateUrl: './businesses.component.html',
  styleUrls: ['./businesses.component.css']
})
export class BusinessesComponent implements OnInit {
  tooltip=`Supported Characters 
  Alphabets
  Numbers
  Spaces
  Special Characters - _'-.# ,?\"$!@*:;%'`;
  isloaded = false;
  public env = environment_state;
  userName: string;
  datalength = lengths;
  newDateFilter = new Date();
  editMinDate: Date;
  tempMinDate: any;
  oWpercent: string;
  isSearch = false;
  Cannabiscountry: any;

  supportedDocType = [];
  supportMaxFileSize = '';
  instructionString = '';
  pdfPreviewSharedWithMe = false;
  isDupPhone = false;
  cloneBusinessData = {};
  totalData = [];
  toggleMenu = false;
  fileManagementTabs = 0;
  toggle = 1;
  displayedColumns4: string[] = ['Select', 'attachment_name', 'bp_business_name', 'bp_doc_type_name', 'updatedby', 'updated', 'Action'];
  displayedColumns4Parent: string[] = ['Name', 'Size', 'Date', 'Action'];
  displayedtemplateSharedWithMeColumns: string[] = ['Name', 'Count'];
  selectionDocs = new SelectionModel<any>(true, []);
  folderList = [
    "Financial Documents", "Tax Documents", "Cannabis License",
    "Formation Documents", "Financial Inst. Applications",
    "Other Documents", "Archived Documents"
  ];

  displayedColumns4ListView = true;
  pdfPreview = false;
  newDocs: any;
  folderDocs = [];
  subDocs = [];
  parentCrum = {};
  crum = [];
  crumItem: any;
  crumCode = '';
  folderParentId = '';
  buId = '';
  docSearchInput = '';
  prevDocSearchInput = '';
  businessInput = {};
  DocFamily = {
    // ID: [],
    // CL: [],
    // TD: [],
    // FD: [],
    // OD: [],
    // FIA: []
  };
  docTypes: any;
  sortcolumn = '';
  sortorder = '';
  message = 'Hola Mundo!';
  minDate = new Date();
  bankDetailEdit = ['Bank Name', 'Routing Number', 'A/C Number', 'Status', 'Action'];
  crumSharedWithMe = [];
  parentCrumSharedWithMe: any = {};
  selectionDocsSharedWithMe = new SelectionModel<any>(true, []);
  displayedColumns4ListViewSharedWithMe = true;
  displayedColumns4ParentSharedWithMe: string[] = ['Name', 'Size'];
  subDocsSharedWithMe = [];
  displayedColumns4SharedWithMe: string[] = ['Select', 'attachment_name', 'Size', 'User', 'Date', 'Action'];
  sharingFilesIndex = 0;
  sharingGroupList = [];
  displayedtemplateSharingGroupColumns: string[] = ['Name', 'Description', 'No of Business', 'Created By', 'Created Date', 'Action'];
  sharingGroupDetails;
  selectedBusiness;
  displayedtemplateSharingGroupDetailsColumns: string[] = ['Name of Business', 'Created By', 'Created Date', 'Action'];
  folderParentIdSharedWithMe = '';
  groupId;
  crumItemSharedWithMe = {};
  docSearchInputSharedWithMe = '';
  @Output() ToggleEvent = new EventEmitter<boolean>();
  @ViewChild('BankEdit') BankEdit: NgForm;
  @ViewChild('BankAdd') BankAdd: NgForm;
  @ViewChild('attachInput') attachInputRef: ElementRef;
  @ViewChild('attachInputEdit') attachInputRefEdit: ElementRef;
  @Output('opened') openedStream: EventEmitter<void>;
  @Output('closed') closedStream: EventEmitter<void>;
  titleNo = this._utils.titleDefault;
  titleNoEdit = this._utils.titleDefault;
  errorMatcherAc = new CrossFieldErrorMatcherAc();
  errorMatcherRouting = new CrossFieldErrorMatcherRouting();
  temsCheckstats = [];
  selectedIndex = 0;
  selectedIndex_inner = 0;
  businessID: string;
  editBusinessID: string;
  businessList = [];
  RegBlock = true;
  RegType = 0;
  RegType_edit = 0;
  phoneTypeList = [];
  businessEntityList = [];
  stateList = [];
  country = [];
  businessLicenseList = [];
  selectableBusiness = [];
  Cannabistates = [];
  CanabisCategorylist = [];
  accreditionstanList = [];
  bankNameList = [];
  // AccountType = [];
  BankDetailsList = [];
  BankDetailsList_edit = [];
  UserList = [];
  UserList_edit = [];
  associationList = [];
  parentCompanyList = [];
  sharedWithMeList = [];
  tabvis = 0;
  tabvis_edit = 0;
  tab = 0;
  editTab = 0;
  other_entity = 0;
  other_entity_edit = 0;
  OtherCanbisCategoy = 0;
  OtherCanbisCategoy_edit = 0;
  Canabis_bus_other_type = 0;
  Canabis_bus_other_type_edit = 0;
  group = 0;
  group1 = 0;
  group2 = 0;
  group_edit = 0;
  group1_edit = 0;
  group2_edit = 0;
  fieldChangeObj = {
    Entity: 'Other'
    , Business: 'Other'
    , Investor: 'Fund'
    , AceessType: 'Admin'
    , CntctPerson: 'contactperson'
    , CanbisCategory: 'Other'
    , Investorvc: 'Venture Capital/Institutional',
  };
  Lab = false;
  Lab_edit = false;
  enableCanabis = true;
  supportedFile = {
    maxSize: '',
    fileSize: 0,
    type: ''
  };
  // page = {
  //   pageSizeOptions: [10, 25, 50, 100]
  //   , limit: 25
  //   , pageSize: 25
  //   , index: 0
  // };
  // taskLists=[];
  // isFiltered=false;
  // fllterForm: any;
  // searchinput: FormGroup; 
  // current_bp_business_id = '';
  BusinessDetailsBasic: FormGroup;
  CannabisDetails: FormGroup;
  ContactDetails: FormGroup;
  BankDetails: FormGroup;
  BeneOwner: FormGroup;
  operators: FormGroup;
  investor: FormGroup;
  contactPerson: FormGroup;
  // Edit
  BusinessDetailsBasic_edit: FormGroup;
  CannabisDetails_edit: FormGroup;
  ContactDetails_edit: FormGroup;
  BankDetails_edit: FormGroup;
  BeneOwner_edit: FormGroup;
  operators_edit: FormGroup;
  investor_edit: FormGroup;
  contactPerson_edit: FormGroup;
  bp_accredition_id: string;
  legal_bt_address_id: string;
  premise_bt_address_id: string;

  items: FormArray;
  Preitems: FormArray;
  tabBtnLabBus = 'NEXT';
  totaltab = 2;
  clnBusinss: string;
  UserControl = {
    BeneOwnerInvestor: false,
    BeneOwnerControl: false,
    ControlBeneOwner: false,
    ControlInvestor: false,
    InvestBeneOwner: false,
    InvestorControl: false,
  };
  UserControl_edit = {
    BeneOwnerInvestor: false,
    BeneOwnerControl: false,
    ControlBeneOwner: false,
    ControlInvestor: false,
    InvestBeneOwner: false,
    InvestorControl: false,
  };
  accessTypeList = [];
  investorTypeList = [];
  titleList = [];
  Nick_name: string;
  api_business_id: string;
  parent_bp_business_id: string;
  bp_business_id:string;
  certificatecopy: File;
  need_fin_inst_acc_assis = false;
  need_fin_inst_acc_assis_edit = false;
  backupZipDetails: any;
  backupZipDetailsPre: any;
  filteredOptions: Observable<string[]>;
  filteredOptions_edit: Observable<string[]>;
  parentCompanyID: string;
  parentCompanyID_edit: string;
  bp_business_license_id: string;
  EditCertificatecopy: File;
  licenseHistory = [];
  selectedSharedWithMe;
  businessSearchInput;
  groupSearchInput;
  filePage = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  folderPage = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  shareWithMeSubfolderPage = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  shareWithMefolderPage = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  sharingGroupfolderPage = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  notiFTabData = [];
  notiFTabDataSMS = [];
  userDataforNotif = [];
  userDataforNotifSMS = [];
  notifHeaders = [];
  notifHeadersSMS = [];
  adminLoggedin = false;
  advancedLoggedin = false;
  membershipActive = false;
  pNotification = true;
  businessIdRetool: string;

  responseURL:string;
  token:string;
  urlSafe: SafeResourceUrl;
  commentsList = false;
  kycStatus=0;
  selectedBusinessRetool: FormControl;
  tntList: any;
  tntType: any;
  showValidationMessage = false;

  
  //Task Management
  is_idme_verified = false;
  code: any;
  callBack = false;
  UserData: any;
  search_input: FormGroup;
  current_bp_business_id: string;
  selectedTaskIndex = 0;
  sortcolumnTask = '';
  singleTaskStatus: any;
  sortorderTask = '';
  searchinput: FormGroup;
  taskDetails = [];
  isFiltered = false;
  dynamicUserActionMenu: any;

  advFilterData = [];
  fllterForm: FormGroup;
  archivefilterForm: FormGroup;
  filters: any;
  archivefilters = [];

  displayedColumns = [
    // 'Assignee Business', 
    'Task Name',
    'Due Date',
    'Assignee',
    'Created Date',
    'Created By',
    'Status',
    'Action'
  ];
  page = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  backBtn: any;
  stateData: any;
  taskID: any;
  
  @ViewChild('tabGroup', { static: true }) tabGroup: MatTabGroup;
  // singleTaskStatus: any;
  // recurringTaskStatus: any;
  // advFilterData: any;
  // filters: any;
  // redirectToViewComponent: any;
  // sortcolumnTask: string;
  // sortorderTask: string;
  // taskDetails: any;

  constructor(private _api: ApiService
    , private route: ActivatedRoute
    , private _utils: UtilitiesService
    , private formBuilder: FormBuilder
    , private customValidator: CustomValidator
    , private dialog: MatDialog
    , private Formvalidator: FormValidatorService
    , private cookieService: CookieService
    , private authService: AuthService
    , private router: Router
    , private spinner: NgxSpinnerService
    , private cookie: CookieService
    , private sanitizer: DomSanitizer) {
      this.router.events.subscribe((val) => {
        if (val instanceof NavigationEnd) {
           if(val.url === '/current_business/auth-message'){
            this.commentsList=true;
          }else{
            this.commentsList=false;
          }
        }
      });
      this.initForms();


      this.search_input = this.formBuilder.group({
        user_email: new FormControl('', [Validators.required]),
          first_name: new FormControl('', [Validators.required]),
          last_name: ['', Validators.required],
      });

      this.route.queryParams.subscribe(params => {
        this.code = params['code'];
        if ( params['code']) {
          this.spinner.show();
  
            this.getIdMe();
  
            // this.router.navigate(['/verification']);
        } else {
  
        }
    });

    this.searchinput = this.formBuilder.group({
      search_field: new FormControl(''),
      task_status: new FormControl(''),
      business: ''
    });

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.backBtn = navigation.extras.state;
    }

  }

  ngOnInit() {
    this.isValidToken();
    setTimeout(() => {
      this.getExpiry();
    });
    this.checkIfRedirected();
    this.getOwnerShipPercent()
    this.getTitleNo();
    this.getSupportedFiles();
    this.getTitleNoEdit();
    this.getRetoolApp();
    this.getUserDetails();
  }

  pendingNotification(){
    this.kycStatus = 1;
  }

  checkIfRedirected() {
    this.route.queryParamMap.subscribe(paramsdata => {
    })
  }

  // isValidToken() {
  //   if (this.cookieService.get('token')) {
  //     this._api.functionPOST('user/getApprovedBusinessCount', {}).subscribe((res) => {
  //       this.is_idme_verified=res['data']['idme_verified'];
  //       if (res['data']['isRestrictedUser']) {
  //         this.router.navigate(['/current_business/profile']);
  //         return;
  //       }
  //       if (!res['data']['email_verified']) {
  //         this.router.navigate(['/']);
  //         this.cookieService.deleteAll('/');
  //         return;
  //       }
  //       if (!res['data']['idme_verified']) {
  //         this.router.navigate(['/verification']);
  //         return;
  //       }
  //       // if (!res['data']['membership_active']) {
  //       //   this.router.navigate(['/pending_approval']);
  //       // }

  //       // if (!res['data']['membership_active']) {
  //       //   this.router.navigate(['/pending_approval']);
  //       // } else {
  //       if (res['data']['is_approved_once'] == 'N') {
  //         this.kycStatus = 2;
  //         this.membershipActive = false;
  //         this.getBusinessList();
  //         return;
  //         // this.router.navigate(['/current_business']);
  //       } else {
  //         this.membershipActive = true;
  //       }
  //       if (!res['data']['membership_active']) {
  //         this.router.navigate(['/pending_approval']);
  //         return;
  //       } else if (res['data']['membership_active']) {
  //         if (res['data']['no_allowedBusinesses'] > 0) {
  //           this.router.navigate(['/dashboard']);
  //         } else {

  //           this.getUserData();
  //           this.getBusinessList();
  //           this.bindDropDowns();
  //         }
  //       }
  //     });
  //   }
  // }

  isValidToken() {
    if (this.cookieService.get('token')) {
      this._api.functionPOST('user/getApprovedBusinessCount', {}).subscribe((res) => {
        this.is_idme_verified=res['data']['idme_verified'];
        if (res['data']['isRestrictedUser']) {
          this.router.navigate(['/current_business/profile']);
          return;
        }
        if (!res['data']['email_verified']) {
          this.router.navigate(['/']);
          this.cookieService.deleteAll('/');
          return;
        }
        // if (!res['data']['idme_verified']) {
        //   this.router.navigate(['/verification']);
        //   return;
        // }
        // if (!res['data']['membership_active']) {
        //   this.router.navigate(['/pending_approval']);
        // }

        // if (!res['data']['membership_active']) {
        //   this.router.navigate(['/pending_approval']);
        // } else {
        if (res['data']['is_approved_once'] == 'N') {
          this.kycStatus = 2;
          this.membershipActive = false;
          this.getBusinessList();
          return;
          // this.router.navigate(['/current_business']);
        } else {
          this.membershipActive = true;
        }
        if (!res['data']['membership_active']) {
          this.router.navigate(['/pending_approval']);
          return;
        } else if (res['data']['membership_active']) {
          if (res['data']['no_allowedBusinesses'] > 0) {
            this.router.navigate(['/dashboard/task-management']);
          } else {

            this.getUserData();
            this.getBusinessList();
            this.bindDropDowns();
          }
        }
      });
    }
  }

  bindDropDowns() {
    this.getBusinessEntityDetails();
    this.getAllStates();
    this.getBusinessLicenseDetails();
    this.getCategory();
    this.getaccreditionStandard();
    // this.getBank_type();
    this.getAccessType();
    this.getInvesterType();
    this.getTitle();
    this.getUserAssociation();
    this.getNotifHeader();
    // this.getParentCompany();
  }
  initForms() {
    // this.searchinput = this.formBuilder.group({
    //   search_field: new FormControl('', Validators.maxLength(100)),
    //   lisence_type: new FormControl('',),
    //   lisence_status: new FormControl(''),
    //   lisence_state: new FormControl(''),
    //   lisence_country: new FormControl(''),
    // });
    this.BusinessDetailsBasic = this.formBuilder.group({
      name: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , dba: new FormControl('', [this.customValidator.hasinitspace])
      , bp_entity_type: new FormControl('')
      // , fed_taxid: new FormControl('', [Validators.required, this.customValidator.hasinitspace, this.customValidator.fedtaxValidator])
      // , incorp_state: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , fed_taxid: new FormControl('', [this.customValidator.hasinitspace, this.customValidator.fedtaxValidator])
      , incorp_state: new FormControl('', [this.customValidator.hasinitspace])
      , bp_entity_type_other: new FormControl('')
      , nickname: new FormControl('')
      , parent_bp_business_id: new FormControl('')
      , business_type: new FormControl('')

      , metrc_type: new FormControl('')
      , metrc_state: new FormControl('')
      , metrc_key: new FormControl('')

    });
    this.CannabisDetails = this.formBuilder.group({
      CanabusBusnessType: new FormControl('', [Validators.required])
      , CanabisCategory: new FormControl('', [Validators.required])
      , CanabusBusnessTypeOther: new FormControl('')
      , CountryList: new FormControl(false, [])
      , is_accredited: new FormControl('', [])
      , accreditation_expiration: new FormControl('')
      , bp_license_type_desig_comment: new FormControl('')
      , certificate_number: new FormControl('')
      , accreditation_standard: new FormControl('')
      , accreditation_test_lab_id: new FormControl('')
      , certificate_image: new FormControl('')
      , isOtherStandard: new FormControl(false)
      , accredition_standard_comment: new FormControl('')
      , accreditation_no: new FormControl('')
      , bp_business_license_id: new FormControl('')
      , CannabisLicensedState: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , CannabisLicenceNumber: new FormControl('', [Validators.required, this.customValidator.hasinitspace,
      this.customValidator.CannabisLicenseValidator])
      , ExpirationDate: new FormControl('')
      , CannabisTaxID: new FormControl('', [this.customValidator.hasinitspace, this.customValidator.CannabisIDvalidator])
    });
    let country = ''
    if(this.country.length > 0){
      country =  this.country[0].bt_country_id
    }
    this.ContactDetails = this.formBuilder.group({
      CountryList: new FormControl(country, [Validators.required, this.customValidator.hasinitspace])
      , ZipCode: new FormControl('', [Validators.required, this.customValidator.hasinitspace, this.validZipCode])
      , zip_id: new FormControl('')
      , State: new FormControl({ value: '', disabled: true })
      , County: new FormControl({ value: '', disabled: true })
      , City: new FormControl({ value: '', disabled: true })
      // , StreetNumber: new FormControl('', [Validators.required,
      // Validators.maxLength(lengths.street_number_max_length), this.customValidator.isValidStreetNum, this.customValidator.isFullSpace])
      , StreetName: new FormControl('', [Validators.required])
      , Unit: new FormControl('', [Validators.maxLength(lengths.unit_max_length)])
      ,BusinessURL: new FormControl('', [Validators.pattern('^(http(s)?://)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/?.*)?$')])
      , is_legal_premise_addr_same: new FormControl('Y')
      , items: this.formBuilder.array([this.createItem()])
      , PreCountryList: new FormControl(country, [Validators.required])
      , PreZipCode: new FormControl('', [Validators.required, this.customValidator.hasinitspace, this.validZipCode])
      , Prezip_id: new FormControl('')
      , PreState: new FormControl({ value: '', disabled: true })
      , PreCounty: new FormControl({ value: '', disabled: true, })
      , PreCity: new FormControl({ value: '', disabled: true })
      // , PreStreetNumber: new FormControl('', [Validators.required,
      // this.customValidator.isFullSpace,
      // Validators.maxLength(lengths.street_number_max_length), this.customValidator.isValidStreetNum])
      , PreStreetName: new FormControl('', [Validators.required])
      , PreUnit: new FormControl('', [Validators.maxLength(lengths.unit_max_length)])
      , Preitems: this.formBuilder.array([this.createItem()])
      , is_correct_zip_legal: new FormControl(false)
      , is_correct_zip_pre: new FormControl(false)
    });
    this.BankDetails = this.formBuilder.group({
      business_bank_routing_number: new FormControl('')
      , business_bank_account_number: new FormControl('')
      , business_bank_name: new FormControl('')
      , ConfirmBankAcNo: new FormControl('')
      , ConfirmBankRoutingNo: new FormControl('')
    }, { validator: [this.bankAcValidator, this.routingNoValidator] });
    this.BeneOwner = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , middlename: new FormControl('')
      , lastname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , email: new FormControl('', [Validators.required, this.customValidator.hasinitspace, Validators.email])
      , ownership_percent: new FormControl('', [Validators.required, this.customValidator.validPercent])
      , role_id: new FormControl('', [Validators.required])
      , is_contact_person: new FormControl('')
      , bp_investor_type_comment: new FormControl('')
      , bp_user_title_id: new FormControl(null)
      , bp_investor_type_id: new FormControl(null)
    });
    this.operators = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , middlename: new FormControl('')
      , lastname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , email: new FormControl('', [Validators.required, this.customValidator.hasinitspace, Validators.email])
      , bp_user_title_id: new FormControl(null)
      , role_id: new FormControl('', [Validators.required])
      , is_contact_person: new FormControl('')
      , bp_investor_type_comment: new FormControl('')
      , bp_investor_type_id: new FormControl(null)
      , ownership_percent: new FormControl(0)
    });
    this.investor = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , middlename: new FormControl('')
      , lastname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , email: new FormControl('', [Validators.required, this.customValidator.hasinitspace, Validators.email])
      , bp_investor_type_id: new FormControl('', [Validators.required])
      , bp_investor_type_comment: new FormControl('', [Validators.required])
      , role_id: new FormControl('', [Validators.required])
      , is_contact_person: new FormControl('')

      , ownership_percent: new FormControl(0)
      , bp_user_title_id: new FormControl(null)
    });
    this.contactPerson = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , middlename: new FormControl('')
      , lastname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , phonenumber: new FormControl('', [Validators.required, this.customValidator.hasinitspace, Validators.minLength(10)])
      , phonetype: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
    });

    // edit

    this.BusinessDetailsBasic_edit = this.formBuilder.group({
      name: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , dba: new FormControl('', [this.customValidator.hasinitspace])
      , bp_entity_type: new FormControl('')
      // , fed_taxid: new FormControl('', [Validators.required, this.customValidator.hasinitspace, this.customValidator.fedtaxValidator])
      // , incorp_state: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , fed_taxid: new FormControl('', [this.customValidator.hasinitspace, this.customValidator.fedtaxValidator])
      , incorp_state: new FormControl('', [this.customValidator.hasinitspace])
      , bp_entity_type_other: new FormControl('')
      , nickname: new FormControl('')
      , parent_bp_business_id: new FormControl('')
      , business_type: new FormControl('')
      , metrc_type: new FormControl('')
      , metrc_state: new FormControl('')
      , metrc_key: new FormControl('')
    });
    this.CannabisDetails_edit = this.formBuilder.group({
      CanabusBusnessType: new FormControl({ value: '', disabled: true }, [Validators.required])
      , CanabisCategory: new FormControl('', [Validators.required])
      , CanabusBusnessTypeOther: new FormControl('')
      , is_accredited: new FormControl(false, [])
      , CountryList: new FormControl('', [])
      , accreditation_expiration: new FormControl('')
      , bp_license_type_desig_comment: new FormControl('')
      , bp_business_license_id: new FormControl('')
      , certificate_number: new FormControl('')
      , accreditation_standard: new FormControl('')
      , accreditation_test_lab_id: new FormControl('')
      , certificate_image: new FormControl('')
      , isOtherStandard: new FormControl(false)
      , accredition_standard_comment: new FormControl('')
      , accreditation_no: new FormControl('')
      , CannabisLicensedState: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , CannabisLicenceNumber: new FormControl('', [Validators.required, this.customValidator.hasinitspace,
      this.customValidator.CannabisLicenseValidator])
      , ExpirationDate: new FormControl('')
      , CannabisTaxID: new FormControl('')
    });
    this.ContactDetails_edit = this.formBuilder.group({
      CountryList: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , ZipCode: new FormControl('', [Validators.required, this.customValidator.hasinitspace, this.validZipCode])
      , zip_id: new FormControl('')
      , State: new FormControl({ value: '', disabled: true })
      , County: new FormControl({ value: '', disabled: true })
      , City: new FormControl({ value: '', disabled: true })
      // , StreetNumber: new FormControl('', [Validators.required,
      // this.customValidator.isFullSpace,
      // Validators.maxLength(lengths.street_number_max_length),
      // this.customValidator.isValidStreetNum])
      , StreetName: new FormControl('', [Validators.required])
      , Unit: new FormControl('', [Validators.maxLength(lengths.unit_max_length)])
      ,BusinessURL: new FormControl('', [Validators.pattern('^(http(s)?://)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/?.*)?$')])
      , is_legal_premise_addr_same: new FormControl('Y')
      , items: this.formBuilder.array([this.createItem()])
      , PreCountryList: new FormControl('', [Validators.required])
      , PreZipCode: new FormControl('', [Validators.required, this.customValidator.hasinitspace, this.validZipCode])
      , Prezip_id: new FormControl('')
      , PreState: new FormControl({ value: '', disabled: true })
      , PreCounty: new FormControl({ value: '', disabled: true, })
      , PreCity: new FormControl({ value: '', disabled: true })
      // , PreStreetNumber: new FormControl('', [Validators.required,
      // this.customValidator.isFullSpace,
      // Validators.maxLength(lengths.street_number_max_length), this.customValidator.isValidStreetNum])
      , PreStreetName: new FormControl('', [Validators.required])
      , PreUnit: new FormControl('', [Validators.maxLength(lengths.unit_max_length)])
      , Preitems: this.formBuilder.array([this.createItem()])
      , is_correct_zip_legal: new FormControl(false)
      , is_correct_zip_pre: new FormControl(false)
    });
    this.BankDetails_edit = this.formBuilder.group({
      business_bank_routing_number: new FormControl('', [this.customValidator.isValidRoutingNo])
      , business_bank_account_number: new FormControl('', [this.customValidator.isValidAccountNo])
      , business_bank_name: new FormControl('')
      , ConfirmBankAcNo: new FormControl('')
      , ConfirmBankRoutingNo: new FormControl('')
    }, { validator: [this.bankAcValidator, this.routingNoValidator] });
    this.BeneOwner_edit = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , middlename: new FormControl('')
      , lastname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , email: new FormControl('', [Validators.required, this.customValidator.hasinitspace, Validators.email])
      , ownership_percent: new FormControl('', [Validators.required, this.customValidator.validPercent])
      , role_id: new FormControl('', [Validators.required])
      , is_contact_person: new FormControl('')
      , bp_investor_type_comment: new FormControl('')
      , bp_user_title_id: new FormControl(null)
      , bp_investor_type_id: new FormControl(null)
    });
    this.operators_edit = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , middlename: new FormControl('')
      , lastname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , email: new FormControl('', [Validators.required, this.customValidator.hasinitspace, Validators.email])
      , bp_user_title_id: new FormControl(null)
      , role_id: new FormControl('', [Validators.required])
      , is_contact_person: new FormControl('')
      , bp_investor_type_comment: new FormControl('')
      , bp_investor_type_id: new FormControl(null)
      , ownership_percent: new FormControl(0)
    });
    this.investor_edit = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , middlename: new FormControl('')
      , lastname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , email: new FormControl('', [Validators.required, this.customValidator.hasinitspace, Validators.email])
      , bp_investor_type_id: new FormControl('', [Validators.required])
      , bp_investor_type_comment: new FormControl('', [Validators.required])
      , role_id: new FormControl('', [Validators.required])
      , is_contact_person: new FormControl('')

      , ownership_percent: new FormControl(0)
      , bp_user_title_id: new FormControl(null)
    });
    this.contactPerson_edit = this.formBuilder.group({
      firstname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , middlename: new FormControl('')
      , lastname: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
      , phonenumber: new FormControl('', [Validators.required, this.customValidator.hasinitspace, Validators.minLength(10)])
      , phonetype: new FormControl('', [Validators.required, this.customValidator.hasinitspace])
    });
    this.zipOnKeyPress(this.ContactDetails_edit, 'ZipCode', 'Legal');
    this.zipOnKeyPress(this.ContactDetails_edit, 'PreZipCode', 'Premise');
    this.zipOnKeyPress(this.ContactDetails, 'ZipCode', 'Legal');
    this.zipOnKeyPress(this.ContactDetails, 'PreZipCode', 'Premise');
    this.bindDropDowns()
    this.getCountryList();
  }
  private _filter(value: string): string[] {
    if (typeof value !== 'string') {
      return null;
    } else {
      const filterValue = value.toLowerCase();
      return this.parentCompanyList.filter(option => option['bp_business_name'].toLowerCase().includes(filterValue));
    }
  }

  getOwnerShipPercent() {
    this._api.functionGET('user/getBeneficialOwnerPercent').subscribe((res) => {
      this.oWpercent = 'ownership >=' + res['data'] + '% is mandatory';
    });
  }
  getUserData() {
    this._api.functionPOST('user/getUserDetailsById', {}).subscribe((res) => {
      const userdetails = res['data']['userData'];
      const firstname = userdetails.firstname;
      const middlename = userdetails.middlename ? userdetails.middlename : '';
      const lastname = userdetails.lastname;
      this.userName = firstname + ' ' + middlename + ' ' + lastname;
      this._utils.creatorID = userdetails.um_user_id;
    });
  }
  getBusinessList() {
    this.spinner.show();
    this._api.functionPOST('user/getUserEditableBusinesses', {}).subscribe((response) => {
      this.businessList = response['data'];
      this.selectedBusinessRetool = new FormControl(this.businessList[0].bp_business_id);
      this.businessIdRetool = this.businessList[0].bp_business_id;
      this.current_bp_business_id = this.businessList[0].bp_business_id;
      // this._api.bizList = response['data'];
      const selectableBusiness = this.businessList.filter(x => x['role_name'] === 'Admin' || x['role_name'] === 'Advanced');
      this.selectableBusiness = selectableBusiness;
      this.clnBusinss = this.selectableBusiness[0] ? this.selectableBusiness[0].bp_business_id : '';
      this.parentCompanyList = response['data'];
      this.filteredOptions = this.BusinessDetailsBasic.get('parent_bp_business_id').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
      this.filteredOptions_edit = this.BusinessDetailsBasic_edit.get('parent_bp_business_id').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
      this.spinner.hide();
    });
  }

  getBusinessListByBp() {
    this._api.functionPOST('business/getUserDetailsById', {}).subscribe((response) => {

    });
  }
  // registration
  // goTOBackTab() {
  //   if (this.tabvis >= 0) {
  //     if (this.RegType === 2 && this.tabvis === 2) {
  //       this.goToTab(this.tabvis - 2);
  //     } else {
  //       this.goToTab(this.tabvis - 1);
  //     }
  //   }
  // }
  goTOBackTab() {
    if (this.tabvis >= 0) {
      if (this.RegType === 2 && this.tabvis === 2) {
        this.goToTab(this.tabvis - 1);
      } else {
        this.goToTab(this.tabvis - 1);
      }
    }
  }
  goToNext() {
    if (this.RegType == 1) {
      this.goToTab(this.tabvis + 1);
    } else {
      if (this.tabvis == 2) {
        this.goToTab(this.tabvis + 2);
      } else {
        this.goToTab(this.tabvis + 1);
      }
    }
    // if (this.tabvis <= this.totaltab) {
    //   if (this.RegType === 2 && this.tabvis === 0) {
    //     this.goToTab(this.tabvis + 2);
    //   } else {
    //     this.goToTab(this.tabvis + 1);
    //   }
    // }
  }
  goToTab(tab) {
    if (tab > this.totaltab) {
      this.validateAndSubmit();
      return;
    }
    switch (tab) {
      case this.totaltab:
        this.tabBtnLabBus = 'SAVE';
        break;

      default:
        this.tabBtnLabBus = 'NEXT';
        break;
    }
    this.tabvis = tab;
    if(this.tabvis === 0){
      this.isValidBusiness({'name':this.BusinessDetailsBasic.get('name').value}, {formGroup:this.BusinessDetailsBasic,formControl:'name'})
      this.isValidBusiness({'nickname':this.BusinessDetailsBasic.get('nickname').value}, {formGroup:this.BusinessDetailsBasic,formControl:'nickname'})
      // this.isValidBusiness({'license':this.CannabisDetails.get('CannabisLicenceNumber').value}, {formGroup:this.CannabisDetails,formControl:'CannabisLicenceNumber'})
    }
  }

  onInputChange(value: string, form: FormGroup): void {
    const city = form.get('PreCity');
    const county = form.get('PreCounty');
    const state = form.get('PreState');
    if (form['value']['is_legal_premise_addr_same']) {
      const Country = form.get('PreCountryList');
      Country.clearValidators();
      Country.updateValueAndValidity();
      const zip = form.get('PreZipCode');
      city.clearValidators();
      state.clearValidators();
      zip.clearValidators();
      zip.updateValueAndValidity();
      // form.get('PreStreetNumber').clearValidators();
      // form.get('PreStreetNumber').updateValueAndValidity();
      form.get('PreStreetName').clearValidators();
      form.get('PreStreetName').updateValueAndValidity();
      for (let i = 0; i < form.get('Preitems')['controls'].length; i++) {
        // form.get('Preitems')['controls'][i]['controls']['phone'].clearValidators();
        // form.get('Preitems')['controls'][i]['controls']['phone'].updateValueAndValidity();
        // form.get('Preitems')['controls'][i]['controls']['phone_type_id'].clearValidators();
        // form.get('Preitems')['controls'][i]['controls']['phone_type_id'].updateValueAndValidity();
      }

      form.patchValue({
        PreStreetName: form['value']['StreetName'],
        Prezip_id: form['value']['zip_id']
      });
    } 
  }


  onTabselect(tab){
    this.tabvis_edit =tab
    if(this.tabvis_edit === 0){
      this.isValidBusiness({'name':this.BusinessDetailsBasic_edit.get('name').value}, {formGroup:this.BusinessDetailsBasic_edit,formControl:'name'})
      this.isValidBusiness({'nickname':this.BusinessDetailsBasic_edit.get('nickname').value}, {formGroup:this.BusinessDetailsBasic_edit,formControl:'nickname'})
      this.isValidBusiness({'license':this.CannabisDetails_edit.get('CannabisLicenceNumber').value}, {formGroup:this.CannabisDetails_edit,formControl:'CannabisLicenceNumber'})
    }
  }
  hasTerms(dataSet) {


    const dialogRef = this.dialog.open(TermsAndConditionComponent, { disableClose: true, data: dataSet, maxWidth: '650px' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.temsCheckstats = result;
        this.BusinessApi();
      }
    });
  }
  openTerms() {
    //   let businessapi = {};
    //   const type = typeof (this.BusinessDetailsBasic.get('parent_bp_business_id').value);
    //   if (type === 'object') {
    //     if (this.BusinessDetailsBasic.get('parent_bp_business_id').value['bp_business_id'] === '') {
    //       businessapi['parent_bp_business_other_name'] = this.BusinessDetailsBasic.get('parent_bp_business_id').value['bp_business_name'];
    //     } else {
    //       businessapi['parent_bp_business_id'] = this.BusinessDetailsBasic.get('parent_bp_business_id').value['bp_business_id'];

    //     }
    //   }
    //   if (type === 'string') {
    //     businessapi['parent_bp_business_other_name'] = this.BusinessDetailsBasic.get('parent_bp_business_id').value;
    //   }

    //  this.BusinessDetailsBasic.reset();
    //   return ;

    this.spinner.show();
    this._api.functionPOST('business/getAgreements', {}).subscribe((response) => {
      this.spinner.hide();
      if (response['data'].length > 0) {
        this.hasTerms(response['data']);
      } else {
        this.BusinessApi();
      }
    });
  }
  // openTerms() {
  //   const dialogRef = this.dialog.open(TermsAndConditionComponent, { disableClose: true });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {

  //       this.temsCheckstats = result;
  //       this.BusinessApi();
  //     }
  //   });
  // }
  validateAndSubmit() {
    if (!this.hasValidUsers('UserList')) {
    } else {

      this.validateForms();

      // this.BusinessApi();
      // this.openBusRegModel();
    }
  }
  hasValidUsers(userList: string) {
    let isAdmin = false;
    let hasCntPsn = false;
    let accessTypeID;
    this.accessTypeList.map((x) => {
      if (x.name === this.fieldChangeObj['AceessType']) {
        accessTypeID = x.um_role_id;
        return false;
      }
    });
    this[userList].map((x) => {
      if (x.role_id === accessTypeID) {
        isAdmin = true;
      }
      if (x.is_contact_person === 'Y') {
        hasCntPsn = true;
      }
      if (x.type === this.fieldChangeObj['CntctPerson']) {
        hasCntPsn = true;
      }
    });
    if (isAdmin && hasCntPsn) {
      return true;
    } else {
      if (!isAdmin && !hasCntPsn) {
        this._api.openSnackBar('at least one admin user and  one contact person required', 'Error');
      } else if (!hasCntPsn) {
        this._api.openSnackBar('at least one contact person required', 'Error');
      } else {
        this._api.openSnackBar('at least one admin user required', 'Error');
      }
      return false;
    }
  }

  shareWithMefolderPageChange(e) {
    this.shareWithMefolderPage.index = e.pageIndex;
    this.shareWithMefolderPage.pageSize = e.pageSize;
    this.getSharedWithMe(this.editBusinessID, { page: e.pageIndex + 1 });
  }

  shareWithMeSubfolderPageChange(e) {
    this.shareWithMeSubfolderPage.index = e.pageIndex;
    this.shareWithMeSubfolderPage.pageSize = e.pageSize;
    this.getAllSharedWithMeDocs(this.selectedSharedWithMe, { page: e.pageIndex + 1 });
  }

  changeEntityType($event, form: FormGroup, entity: string) {
    const otherEntity = form.get('bp_entity_type_other');
    this.businessEntityList.map((x) => {
      if ($event.value === x.bp_entity_type_id) {
        if (x.name === this.fieldChangeObj['Entity']) {
          this[entity] = 1;
          otherEntity.setValidators([Validators.required, this.customValidator.hasinitspace]);
          otherEntity.updateValueAndValidity();
          return false;
        } else {
          this[entity] = 0;
          otherEntity.clearValidators();
          otherEntity.updateValueAndValidity();
        }

      }
    });
  }
  changeCannBussType($event, form: FormGroup, otherBusinessCat: string, enableKey) {

    const otherBusiness = form.get('CanabusBusnessTypeOther');
    this.businessLicenseList.map((x) => {
      if ($event.value['bp_license_type_id'] === x.bp_license_type_id) {
        if (x.name === this.fieldChangeObj['Business']) {
          this[otherBusinessCat] = 1;
          // otherBusiness.setValidators([Validators.required, this.customValidator.hasinitspace]);
          otherBusiness.updateValueAndValidity();
          return false;
        } else {
          this[otherBusinessCat] = 0;
          otherBusiness.clearValidators();
          otherBusiness.updateValueAndValidity();
        }

      }
    });

    if ($event.value['is_accredited']) {
      this[enableKey] = true;
    } else {
      this[enableKey] = false;
      form.patchValue({
        is_accredited: false
      }
      );
    }
    // this.IsAcreditedLab(false , form , 'ss');
  }
  IsAcreditedLab(labstats: boolean, form: FormGroup) {

    if (labstats) {
      form.get('accreditation_expiration').setValidators([Validators.required]);
      form.get('accreditation_expiration').updateValueAndValidity();
      form.get('accredition_standard_comment').setValidators([Validators.required]);
      form.get('accredition_standard_comment').updateValueAndValidity();
      form.get('accreditation_standard').setValidators([Validators.required]);
      form.get('accreditation_standard').updateValueAndValidity();
      form.get('accreditation_test_lab_id').setValidators([Validators.required, this.customValidator.hasinitspace]);
      form.get('accreditation_test_lab_id').updateValueAndValidity();
      form.get('certificate_number').setValidators([Validators.required, this.customValidator.hasinitspace]);
      form.get('certificate_number').updateValueAndValidity();
      form.get('accreditation_no').setValidators([Validators.required, this.customValidator.hasinitspace]);
      form.get('accreditation_no').updateValueAndValidity();
      form.get('certificate_image').setValidators([Validators.required, this.customValidator.hasinitspace]);
      form.get('certificate_image').updateValueAndValidity();
    } else {

      form.get('accreditation_expiration').clearValidators();
      form.get('accreditation_expiration').updateValueAndValidity();
      form.get('accreditation_standard').clearValidators();
      form.get('accreditation_standard').updateValueAndValidity();
      form.get('accreditation_test_lab_id').clearValidators();
      form.get('accreditation_test_lab_id').updateValueAndValidity();
      form.get('certificate_number').clearValidators();
      form.get('certificate_number').updateValueAndValidity();
      form.get('accreditation_no').clearValidators();
      form.get('accreditation_no').updateValueAndValidity();
      form.get('certificate_image').clearValidators();
      form.get('certificate_image').updateValueAndValidity();
      form.get('accredition_standard_comment').clearValidators();
      form.get('accredition_standard_comment').updateValueAndValidity();

    }
  }
  getBusinessEntityDetails() {
    this._api.functionGET('business/entity_type').subscribe((res) => {
      this.businessEntityList = res['data'];
    },
      err => {

      });
  }
  onChangeindex(index){
    console.log('----------index', index, this.is_idme_verified);

    this.selectedIndex = index;
    this.initForms();
    if (index === 2) {
      console.log('--------------2222');
      this.getRetoolApp();
    }
    // if (index === 1 && !this.is_idme_verified) {
    //   console.log('--------------1111');
    //   this.getRetoolApp();
    // }
    if (index === 3 && this.is_idme_verified) {
      this.getAllTaskList({page: 1})
      this.getTaskStatus();
      this.orderFilterAttr();
    }
    if (index === 2 && !this.is_idme_verified) {
      this.getAllTaskList({page: 1})
      this.getTaskStatus();
      this.orderFilterAttr();
    }

  }
  getBusinessLicenseDetails() {
    this._api.functionGET('business/license_type', {}).subscribe((res) => {
      this.businessLicenseList = res['data'];
    },
      err => {

      });
  }
  getAllStates() {
    this._api.functionGET('country/allStates').subscribe((res) => {
      this.stateList = res['data'];
    },
      err => {
      });
  }
  getPhoneType() {
    this._api.functionGET('phones/getPhoneType', {}).subscribe((res) => {
      this.isloaded = true;
      this.phoneTypeList = res['data'];

    },
      err => {
      });
  }

  getCannabisStates(id) {
    this._api.functionGET('country/cannabisStates?bt_country_id=' + id).subscribe((res) => {
      this.Cannabistates = res['data'];
    },
      err => {
      });
  }
  getCategory() {
    this._api.functionGET('business/license_category', {}).subscribe((res) => {
      this.CanabisCategorylist = res['data'];
    },
      err => {

      });
  }
  getCountryList() {
    this._api.functionGET('country/allcountry').subscribe((res) => {
      this.country = res['data'];
      this.ContactDetails.patchValue({
        CountryList: this.country[0].bt_country_id
        , PreCountryList: this.country[0].bt_country_id
      });
      this.getPhoneType();
      this.getCannabisCountryList();

    },
      err => {
      });
  }
  getCannabisCountryList(country?) {
    this._api.functionGET('country/list').subscribe((res) => {
      this.Cannabiscountry = res['data'];

      if(country){
        this.getCannabisStates(country);
        this.CannabisDetails.patchValue({
          CountryList: country
        });
        this.CannabisDetails_edit.patchValue({
          CountryList: country
        });
      } else {
        this.CannabisDetails.patchValue({
          CountryList: this.Cannabiscountry[0].bt_country_id
        });
        this.CannabisDetails_edit.patchValue({
          CountryList: this.Cannabiscountry[0].bt_country_id
        });
        this.getTntTypes();
        this.getCannabisStates(this.Cannabiscountry[0].bt_country_id);
      }
    },
      err => {
      });
  }
  getaccreditionStandard() {
    this._api.functionGET('business/accredition_standard_type', {}).subscribe((res) => {
      this.accreditionstanList = res['data'];
    },
      err => {
      });
  }
  getInvesterType() {
    this._api.functionGET('business/investor_type', {}).subscribe((res) => {
      this.investorTypeList = res['data'];
    },
      err => {
      });
  }
  getAccessType() {
    this._api.functionGET('business/user_roles', {}).subscribe((res) => {
      this.accessTypeList = res['data'];
    },
      err => {
      });
  }
  getTitle() {
    this._api.functionGET('business/user_titles', {}).subscribe((res) => {
      this.titleList = res['data'];
    },
      err => {
      });
  }
  getUserAssociation() {
    this._api.functionGET('business/user_association_type', {}).subscribe((res) => {
      this.associationList = res['data'];
    },
      err => {
      });
  }
  getParentCompany() {
    this._api.functionGET('business/business_nicknames').subscribe((res) => {
      this.parentCompanyList = res['data'];
      this.filteredOptions = this.BusinessDetailsBasic.get('parent_bp_business_id').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
      this.filteredOptions_edit = this.BusinessDetailsBasic_edit.get('parent_bp_business_id').valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    },
      err => {

      });
  }
  getNickname($event, form: FormGroup, parentCompany) {

    form.patchValue({
      parent_bp_business_id: $event.option.value['nickname']
    });
    this[parentCompany] = $event.option.value['bp_business_id'];
  }
  changeStandard($event, form: FormGroup) {
    const Standard = form.get('accredition_standard_comment');
    this.accreditionstanList.map((x) => {
      if ($event.value === x.bp_accredition_standard_type_id) {
        if (x.name === 'Other ') {
          form.patchValue({
            isOtherStandard: true
          }
          );
          Standard.setValidators([Validators.required,]);
          Standard.updateValueAndValidity();
          return false;

        } else {
          form.patchValue({
            isOtherStandard: false
          }
          );
          Standard.reset();
          Standard.clearValidators();
          Standard.updateValueAndValidity();
        }
      }

    });

  }
  createItem(): FormGroup {
    let type = '';
    if(this.phoneTypeList.length > 0){
     type = this.phoneTypeList[1].bt_phone_type_id
    } else {
      type = ''
    }
    return this.formBuilder.group({
      phone: new FormControl(''),
      phone_type_id: new FormControl(type)
    });
  }
  updatePhone(data: {}): FormGroup {
    return this.formBuilder.group({
      phone: new FormControl(data['phone']),
      phone_type_id: new FormControl(data['phone_type_id'])
    });
  }
  validZipCode(control: AbstractControl): ValidationErrors | null {
    return { validZip: true };
  }
  bankAcValidator(form: FormGroup) {
    const condition = form.get('business_bank_account_number').value !== form.get('ConfirmBankAcNo').value;
    return condition ? { AcnoDoNotMatch: true } : null;
  }
  routingNoValidator(form: FormGroup) {
    const condition = form.get('business_bank_routing_number').value !== form.get('ConfirmBankRoutingNo').value;
    return condition ? { routingNoDoNotMatch: true } : null;
  }
  findZipBusinessDetails(form: FormGroup) {
    const zipcode = form.get('ZipCode');
    const country = form.get('CountryList');
    const isCorrectZip = form.get('is_correct_zip_legal').value;
    const isSameAddress = form.get('is_legal_premise_addr_same').value;
    if (!zipcode.value) {
      zipcode.setValidators([Validators.required, this.customValidator.hasinitspace, this.validZipCode]);
      zipcode.updateValueAndValidity();
      form.patchValue({
        City: '',
        County: '',
        State: ''
      });
      return;
    }
    const data = {
      zipcode: zipcode.value
      , Country: country.value
    };
    this.spinner.show();
    this._api.functionPOST('zipcode/findZip', data).subscribe((res) => {
      this.spinner.hide();
      if (res['data'].length === 0) {
        zipcode.setValidators([Validators.required, this.customValidator.hasinitspace, this.validZipCode]);
        zipcode.updateValueAndValidity();
        this._api.openSnackBar('Zip Code not found', 'Error');
        // form.patchValue({
        //   City: '',
        //   County: '',
        //   State: ''
        // });
        return;
      }
      this.backupZipDetails = res['data'][0];
      if (!isCorrectZip) {
        form.patchValue({
          City: res['data'][0].city,
          County: res['data'][0].county,
          State: res['data'][0].bt_region.name
        });
      }
      if (isSameAddress) {
        form.patchValue({
          PreZipCode: res['data'][0].zipcode,
          PreCity: res['data'][0].city,
          PreCounty: res['data'][0].county,
          PreState: res['data'][0].bt_region.name,
        });
      }
      form.patchValue({
        zip_id: res['data'][0].bt_zipcodes_id,
        PreZip_id: res['data'][0].bt_zipcodes_id
      });
      zipcode.clearValidators();
      zipcode.updateValueAndValidity();
    },
      err => {
        this._api.openSnackBar(err['error'], 'Error');
        zipcode.setValidators([Validators.required, this.customValidator.hasinitspace, this.validZipCode]);
        zipcode.updateValueAndValidity();
      });
  }
  findZipBusinessDetailsPrem(form: FormGroup) {
    console.log('------------premise_bt_zipcodes_id', form);
    const zipcode = form.get('PreZipCode');
    console.log('===================prezip', zipcode);
    const country = form.get('PreCountryList');
    const ispremise = form.get('is_legal_premise_addr_same');
    const isCorrectZip = form.get('is_correct_zip_pre').value;
    const isSameAddress = form.get('is_legal_premise_addr_same').value;
    if (!ispremise.value) {
      if (!zipcode.value) {
        zipcode.setValidators([this.customValidator.hasinitspace, this.validZipCode]);
        zipcode.updateValueAndValidity();
        form.patchValue({
          PreCity: '',
          PreCounty: '',
          PreState: ''
        });
        return;
      }
      const data = {
        zipcode: zipcode.value
        , Country: country.value
      };
      ispremise.disable();
      this.spinner.show();
      this._api.functionPOST('zipcode/findZip', data).subscribe((res) => {
        this.spinner.hide();
        ispremise.enable();
        if (res['data'].length === 0) {
          zipcode.setValidators([this.customValidator.hasinitspace, this.validZipCode]);
          zipcode.updateValueAndValidity();
          this._api.openSnackBar('Zip Code not found', 'Error');
          // form.patchValue({
          //   PreCity: '',
          //   PreCounty: '',
          //   PreState: ''
          // });
          return;
        }
        this.backupZipDetailsPre = res['data'][0];
        if (!isCorrectZip) {
          form.patchValue({
            PreCity: res['data'][0].city,
            PreCounty: res['data'][0].county,
            PreState: res['data'][0].bt_region.name
          });
        }
        if (isSameAddress) {
          form.patchValue({
            PreZipCode: res['data'][0].zipcode,
            PreCity: res['data'][0].city,
            PreCounty: res['data'][0].county,
            PreState: res['data'][0].bt_region.name,
          });
        }
        form.patchValue({
          Prezip_id: res['data'][0].bt_zipcodes_id
        });

        zipcode.clearValidators();
        zipcode.updateValueAndValidity();
      },
        err => {
          this._api.openSnackBar(err['error'], 'Error');
          zipcode.setValidators([Validators.required, this.customValidator.hasinitspace, this.validZipCode]);
          zipcode.updateValueAndValidity();
          ispremise.enable();
        });
    }
  }
  BusinessDetailsIncorrectZip($event, form: FormGroup) {
    const city = form.get('City');
    const county = form.get('County');
    const state = form.get('State');

    if ($event.checked) {
      city.enable();
      county.enable();
      state.enable();
      city.setValidators([Validators.required, this.customValidator.isFullSpace]);
      state.setValidators([Validators.required, this.customValidator.isFullSpace]);

    } else {
      city.disable();
      county.disable();
      state.disable();
      city.clearValidators();
      state.clearValidators();
      form.patchValue({
        City: (this.backupZipDetails) ? this.backupZipDetails['city'] : ''
        , County: (this.backupZipDetails) ? this.backupZipDetails['county'] : ''
        , State: (this.backupZipDetails) ? this.backupZipDetails['bt_region']['name'] : ''
      });
      // this.findZipBusinessDetails();
    }

    city.updateValueAndValidity();
    // county.updateValueAndValidity();
    state.updateValueAndValidity();
  }
  BusinessDetailsPreIncorrectZip($event, form: FormGroup) {
    const city = form.get('PreCity');
    const county = form.get('PreCounty');
    const state = form.get('PreState');

    if ($event.checked) {
      city.enable();
      county.enable();
      state.enable();

      city.setValidators([Validators.required, this.customValidator.isFullSpace]);
      // county.setValidators([Validators.required,customValidator.hasinitspace]);
      state.setValidators([Validators.required, this.customValidator.isFullSpace]);

    } else {
      city.disable();
      county.disable();
      state.disable();

      city.clearValidators();
      //  county.clearValidators();
      state.clearValidators();
      form.patchValue({
        PreCity: (this.backupZipDetailsPre) ? this.backupZipDetailsPre['city'] : ''
        , PreCounty: (this.backupZipDetailsPre) ? this.backupZipDetailsPre['county'] : ''
        , PreState: (this.backupZipDetailsPre) ? this.backupZipDetailsPre['bt_region']['name'] : ''
      });
    }

    city.updateValueAndValidity();
    county.updateValueAndValidity();
    state.updateValueAndValidity();
  }
  // DisableBusines_Validation(form: FormGroup) {
  //   const city = form.get('PreCity');
  //   const county = form.get('PreCounty');
  //   const state = form.get('PreState');

  //   if (form.get('is_legal_premise_addr_same').value) {
  //     const Country = form.get('PreCountryList');
  //     Country.clearValidators();
  //     Country.updateValueAndValidity();
  //     const zip = form.get('PreZipCode');
  //     city.clearValidators();
  //     state.clearValidators();
  //     zip.clearValidators();
  //     zip.updateValueAndValidity();
  //     // form.get('PreStreetNumber').clearValidators();
  //     // form.get('PreStreetNumber').updateValueAndValidity();
  //     form.get('PreStreetName').clearValidators();
  //     form.get('PreStreetName').updateValueAndValidity();
  //     // for (let i = 0; i < form.get('Preitems')['controls'].length; i++) {
  //     //   form.get('Preitems')['controls'][i]['controls']['phone'].clearValidators();
  //     //   form.get('Preitems')['controls'][i]['controls']['phone'].updateValueAndValidity();
  //     //   form.get('Preitems')['controls'][i]['controls']['phone_type_id'].clearValidators();
  //     //   form.get('Preitems')['controls'][i]['controls']['phone_type_id'].updateValueAndValidity();
  //     // }
  //   } else {
  //     form.patchValue({
  //       // PreCountryList: this.country[0].bt_country_id,
  //       PreCity: '',
  //       PreState: '',
  //       PreStreetName: '',
  //       Prezip_id: '',
  //       PreZipCode: ''
  //     });
  //     // form.patchValue({
  //     //   PreCountryList: this.country[0].bt_country_id
  //     // });
  //     const Country = form.get('PreCountryList');
  //     Country.setValidators([Validators.required]);
  //     Country.updateValueAndValidity();
  //     const zip = form.get('PreZipCode');
  //     if (form.get('is_correct_zip_pre').value) {
  //       city.setValidators([Validators.required]);
  //       //  county.setValidators([Validators.required,this.customValidator.hasinitspace]);
  //       state.setValidators([Validators.required]);
  //     }
  //     zip.setValidators([Validators.required, this.customValidator.hasinitspace]);
  //     zip.updateValueAndValidity();
  //     // form.get('PreStreetNumber').setValidators([Validators.required
  //     //   , this.customValidator.isValidStreetNum
  //     //   , this.customValidator.isFullSpace
  //     //   , Validators.maxLength(lengths.unit_max_length)]);
  //     // form.get('PreStreetNumber').updateValueAndValidity();
  //     form.get('PreStreetName').setValidators([Validators.required]);
  //     form.get('PreStreetName').updateValueAndValidity();
  //     form.get('PreUnit').setValidators([Validators.maxLength(lengths.unit_max_length)]);
  //     form.get('PreUnit').updateValueAndValidity();
  //     // for (let i = 0; i < form.get('Preitems')['controls'].length; i++) {
  //     //   form.get('Preitems')['controls'][i]['controls']['phone'].setValidators([Validators.required, this.customValidator.hasinitspace, this.customValidator.isAllZero]);
  //     //   form.get('Preitems')['controls'][i]['controls']['phone'].updateValueAndValidity();
  //     //   form.get('Preitems')['controls'][i]['controls']['phone_type_id'].setValidators([Validators.required]);
  //     //   form.get('Preitems')['controls'][i]['controls']['phone_type_id'].updateValueAndValidity();
  //     // }
  //   }
  //   city.updateValueAndValidity();
  //   // county.updateValueAndValidity();
  //   state.updateValueAndValidity();
  // }

  DisableBusines_Validation(form: FormGroup) {
    const city = form.get('PreCity');
    const county = form.get('PreCounty');
    const state = form.get('PreState');

    if (form.get('is_legal_premise_addr_same').value) {
      const Country = form.get('PreCountryList');
      Country.clearValidators();
      Country.updateValueAndValidity();
      const zip = form.get('PreZipCode');
      city.clearValidators();
      state.clearValidators();
      zip.clearValidators();
      zip.updateValueAndValidity();
      // form.get('PreStreetNumber').clearValidators();
      // form.get('PreStreetNumber').updateValueAndValidity();
      form.get('PreStreetName').clearValidators();
      form.get('PreStreetName').updateValueAndValidity();
      for (let i = 0; i < form.get('Preitems')['controls'].length; i++) {
        form.get('Preitems')['controls'][i]['controls']['phone'].clearValidators();
        form.get('Preitems')['controls'][i]['controls']['phone'].updateValueAndValidity();
        form.get('Preitems')['controls'][i]['controls']['phone_type_id'].clearValidators();
        form.get('Preitems')['controls'][i]['controls']['phone_type_id'].updateValueAndValidity();
      }
    } else {
      if(!form.get('PreCountryList').value)
        form.patchValue({
          PreCountryList: this.country[0].bt_country_id,
          PreCity: '',
          PreState: '',
          PreStreetName: '',
          Prezip_id: '',
          PreZipCode: ''
        });
      // form.patchValue({
      //   PreCountryList: this.country[0].bt_country_id,
      //   PreCity: '',
      //   PreState: '',
      //   PreStreetName: '',
      //   Prezip_id: '',
      //   PreZipCode: ''
      // });
      const Country = form.get('PreCountryList');
      Country.setValidators([Validators.required]);
      Country.updateValueAndValidity();
      const zip = form.get('PreZipCode');
      if (form.get('is_correct_zip_pre').value) {
        city.setValidators([Validators.required]);
        //  county.setValidators([Validators.required,this.customValidator.hasinitspace]);
        state.setValidators([Validators.required]);
      }
      zip.setValidators([Validators.required, this.customValidator.hasinitspace]);
      zip.updateValueAndValidity();
      // form.get('PreStreetNumber').setValidators([Validators.required, this.customValidator.isValidStreetNum, this.customValidator.isFullSpace]);
      // form.get('PreStreetNumber').updateValueAndValidity();
      form.get('PreStreetName').setValidators([Validators.required]);
      form.get('PreStreetName').updateValueAndValidity();
      form.get('PreUnit').setValidators([Validators.maxLength(lengths.unit_max_length)]);
      form.get('PreUnit').updateValueAndValidity();
      for (let i = 0; i < form.get('Preitems')['controls'].length; i++) {
        form.get('Preitems')['controls'][i]['controls']['phone'].setValidators([this.customValidator.hasinitspace]);
        form.get('Preitems')['controls'][i]['controls']['phone'].updateValueAndValidity();
        form.get('Preitems')['controls'][i]['controls']['phone_type_id'].setValidators();
        form.get('Preitems')['controls'][i]['controls']['phone_type_id'].updateValueAndValidity();
      }
    }
    city.updateValueAndValidity();
    // county.updateValueAndValidity();
    state.updateValueAndValidity();
  }
  
  IsOtherCategory($event, form: FormGroup, otherCannabis: string) {
    const othercannabiscategory = form.get('bp_license_type_desig_comment');

    this.CanabisCategorylist.map((x) => {
      if ($event.value === x.bp_license_type_desig_id) {
        if (x.name === this.fieldChangeObj['CanbisCategory']) {
          this[otherCannabis] = 1;
          othercannabiscategory.setValidators([Validators.required, this.customValidator.hasinitspace]);
          othercannabiscategory.updateValueAndValidity();
          return false;

        } else {
          this[otherCannabis] = 0;
          othercannabiscategory.setValue(null);
          othercannabiscategory.clearValidators();
          othercannabiscategory.updateValueAndValidity();
        }
      }

    });
  }
  addItem(form: FormGroup, formArray: string): void {
    this[formArray] = form.get(formArray) as FormArray;
    this[formArray].push(this.createItem());
  }
  CloseItem(item, form: FormGroup, formArray: string) {
    this[formArray] = form.get(formArray) as FormArray;
    this[formArray].controls.map((x, i) => {
      if (x === item) {
        this[formArray].removeAt(i);
      }
    });
    this.isDuplicatePhone();
  }

  addBankDetails(form: FormGroup, bankList: string) {
    const hasSame = this.isSameAccount(bankList
      , (form.value['business_bank_account_number']).toString()
      , form.value.business_bank_routing_number.fin_financial_inst_routing_id
    );
    if (hasSame) {
      this._api.openSnackBar('Account no already exist', 'Error');
      return;
    }

    const obj = {
      // business_bank_account_number: (form.value['business_bank_account_number']).toString(),
      business_bank_account_number: (form.value['business_bank_account_number']),
      //  business_bank_account_type: form.value['business_bank_account_type'],
      business_bank_routing_number: form.value.business_bank_routing_number.fin_financial_inst_routing_id,
      business_bank_name: form.value.business_bank_name.fin_financial_inst_id,
    };
    this[bankList].push(obj);
    this.BankAdd.resetForm();
    // this.setAccountTypeDefault(form);
  }
  maskAccountNo(value: any) {
    const acno = value.toString();
    return '******' + acno.slice(-4);
  }
  isSameAccount(bankList: string, accountNo: any, routingNo: string) {
    return (this[bankList] as Array<any>).some((x) => x.business_bank_account_number === accountNo && x.business_bank_routing_number === routingNo);
  }
  addBankDetails_edit(form: FormGroup, bankList: string) {
    if(parseInt(form.value.business_bank_routing_number)<=0){
      this._api.openSnackBar('Please provide valid routing number', 'Error');
      return;
     }
     if(parseInt(form.value['business_bank_account_number'])<=0){
      this._api.openSnackBar('Please provide valid account number', 'Error');
      return;
     }
    this.spinner.show();
    const obj = {
      // business_bank_account_number: (form.value['business_bank_account_number']).toString(),
      // business_bank_routing_number: (form.value.business_bank_routing_number).toString(),
      business_bank_account_number: (form.value['business_bank_account_number']),
      business_bank_routing_number: (form.value.business_bank_routing_number),
      business_bank_name: form.value.business_bank_name,
      need_fin_inst_acc_assist: this.need_fin_inst_acc_assis_edit ? 'Y' : 'N'
    };
    const apiObj = obj;
    apiObj['business_id'] = this.editBusinessID;
    this._api.functionPOST('business/updateBankDetails', apiObj).subscribe((response) => {
      if (response['success']) {
        obj.business_bank_account_number = this.maskAccountNo(obj.business_bank_account_number);
        obj['bp_business_financial_inst_id'] = response['data']['bp_business_financial_inst_id'];
        obj['business_bank_name'] = form.value.business_bank_name;
        obj['fin_financial_inst_bp_status_name'] = response['data']['status'];
        this[bankList].push(obj);
        this[bankList] = this._utils.tableParser(this[bankList]);
        this.BankEdit.resetForm();
        this._api.openSnackBar(response['data']['message'], 'success');
        // this.setAccountTypeDefault(form);
      }
      this.spinner.hide();
    });
  }
  // setAccountTypeDefault(form: FormGroup) {
  //   let defaultType = '';
  //   this.AccountType.map((x) => {
  //     if (x.name === 'Clearing') {
  //       defaultType = x.fin_financial_acc_type_id;
  //       return false;
  //     }
  //   });
  //   form.patchValue({
  //     business_bank_name: this.bankNameList[0]
  //     , business_bank_account_type: defaultType
  //   });
  // }
  deleteBankDetails(item, bankDetailsList: string) {
    this[bankDetailsList].map((x, i) => {
      if (x === item) {
        this[bankDetailsList].splice(i, 1);
      }
    });
  }
  deleteBankDetails_edit(item, bankDetailsList: string) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      maxWidth: '350px'
      , data: {
        msg: 'Are you sure you want to delete this ?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        const obj = {
          business_id: this.editBusinessID
          , bp_business_financial_inst_id: item.bp_business_financial_inst_id
        };
        this._api.functionPOST('business/deleteBankDetails', obj).subscribe((response) => {
          if (response['success']) {
            this[bankDetailsList].map((x, i) => {
              if (x === item) {
                this[bankDetailsList].splice(i, 1);
              }
            });
            this[bankDetailsList] = this._utils.tableParser(this[bankDetailsList]);
            this._api.openSnackBar(response['data'], 'Success');
          }
          this.spinner.hide();
        });
      }
    });
  }
  SetTab(tabpos) {
    this.tab = tabpos;
  }
  hasSameEmail(email, userList: string) {
    let rtn: boolean;
    this[userList].map((x) => {
      if (x.email === email) {
        rtn = true;
        return false;
      }
    });
    return rtn;
  }
  hasEmailTwise(email, userList: string) {
    let count = 0;
    this[userList].map((x) => {
      if (x.email === email) {
        count = count + 1;
      }
    });
    if (count > 1) {
      return true;
    } else {
      return false;
    }

  }

  addUsers(formdata: FormGroup, checkBox: string, userList: string, Page?: string) {

    if (this[userList].length > 0) {
      if (this.hasSameEmail(formdata.value['email'], userList)) {
        this._api.openSnackBar('This email already exist', 'Error');
        return;
      }
    }
    if (formdata.value.hasOwnProperty('is_contact_person')) {
      if (formdata.value['is_contact_person']) {
        for (let i = 0; i < this[userList].length; i++) {
          this[userList][i]['is_contact_person'] = 'N';
        }
        formdata.value['is_contact_person'] = 'Y';
      } else {
        formdata.value['is_contact_person'] = 'N';
      }
    }
    let ascId;
    let ascName;
    let type;
    const assocNameArray = [];
    const tab = Page === 'add' ? this.tab : this.editTab;
    this.spinner.show();
    switch (tab) {
      case 1:
        ascName = 'Beneficial owner';
        type = 'beneficial_owners';
        if (this[checkBox].BeneOwnerInvestor) { assocNameArray.push('Investor'); }
        if (this[checkBox].BeneOwnerControl) { assocNameArray.push('Controlling Managers & Operators'); }
        assocNameArray.push('Beneficial owner');
        break;
      case 2:
        ascName = 'Controlling Managers & Operators';
        type = 'controlling_managers';
        if (this[checkBox].ControlBeneOwner) { assocNameArray.push('Beneficial owner'); }
        if (this[checkBox].ControlInvestor) { assocNameArray.push('Investor'); }
        assocNameArray.push('Controlling Managers & Operators');
        break;
      case 3:
        ascName = 'Investor';
        type = 'investor';
        if (this[checkBox].InvestBeneOwner) { assocNameArray.push('Beneficial owner'); }
        if (this[checkBox].InvestorControl) { assocNameArray.push('Controlling Managers & Operators'); }
        assocNameArray.push('Investor');
        break;
      case 4:
        ascName = 'ContactPerson';
        type = 'contactperson';
        break;
      default:
        break;
    }
    const assocIdArray = [];
    assocNameArray.map((z) => {
      this.associationList.map((x) => {
        if (z === x.name) {
          if (Page === 'Edit') {
            assocIdArray.push(x.bp_user_association_id);
            // assocIdArray.push({ bp_user_association_id: x.bp_user_association_id });
          } else {
            assocIdArray.push(x.bp_user_association_id);
          }
          return false;
        }
      });
    });
    const userObj = formdata.value;
    userObj['user_associations'] = assocIdArray;
    userObj['type'] = type;
    userObj['middlename'] = userObj['middlename'] ? userObj['middlename'] : '';
    if (Page === 'Edit') {
      userObj['business_id'] = this.editBusinessID;
      this._api.functionPOST('business/addNewBusinessUsers', userObj).subscribe((response) => {
        if (response['success']) {
          userObj['um_user_id'] = response['data']['user_id'];
          userObj['bp_business_user_assoc_id'] = response['data']['bp_business_user_assoc_id'];
          this._api.openSnackBar(response['data']['message'], 'Succes');
          this[userList].push(userObj);
          this.BeneOwner_edit.reset();
          this.operators_edit.reset();
          this.contactPerson_edit.reset();
          this.investor_edit.reset();
          this.resetRegForm('group1_edit', 'editTab', this.BeneOwner_edit, 'UserControl_edit', 'beneOwner');
          this.resetRegForm('group2_edit', 'editTab', this.operators_edit, 'UserControl_edit', 'operator');
          this.resetRegForm('group_edit', 'editTab', this.investor_edit, 'UserControl_edit', 'investor');
          this._utils.ReadMessage(true);
          if (this.adminLoggedin) {
            this.getNotifData();
            this.getNotifDataSMS();
          }
          this.editTab = 0;
          this.spinner.hide();
        }
      });
    } else {
      this[userList].push(userObj);

      this.BeneOwner.reset();
      this.operators.reset();
      this.contactPerson.reset();
      this.investor.reset();
      this.tab = 0;
      this.resetRegForm('group1', 'tab', this.BeneOwner, 'UserControl', 'beneOwner');
      this.resetRegForm('group', 'tab', this.investor, 'UserControl', 'investor');
      this.resetRegForm('group2', 'tab', this.operators, 'UserControl', 'operator');
      this.spinner.hide();
    }

  }
  resetForm_edit() {
    this.Lab_edit = false;
    this.BeneOwner_edit.reset();
    this.operators_edit.reset();
    this.contactPerson_edit.reset();
    this.investor_edit.reset();
    this.BusinessDetailsBasic_edit.reset();
    this.BusinessDetailsBasic_edit.patchValue({
      parent_bp_business_id: '',
      dba: '',
    });
    this.CannabisDetails_edit.reset();
    this.ContactDetails_edit.reset();
    this.ContactDetails_edit.patchValue({
      is_accredited: false
    });
    this.BankDetails_edit.reset();
    this.BankDetailsList_edit = [];
    this.UserList_edit = [];
  }
  resetForm_Add() {
    this.Lab = false;
    this.BusinessDetailsBasic.reset();
    this.BusinessDetailsBasic.patchValue({
      parent_bp_business_id: '',
      dba: ''
    });
    this.CannabisDetails.reset();
    this.CannabisDetails.patchValue({
      is_accredited: false
    });
    this.ContactDetails.reset();
    this.ContactDetails.patchValue({
      CountryList: this.country[0].bt_country_id
    });
    this.BankDetails.reset();
    this.BeneOwner.reset();
    this.operators.reset();
    this.contactPerson.reset();
    this.investor.reset();
    this.BankDetailsList = [];
    this.UserList = [];

  }
  deleteUser(item, userList: string) {
    this[userList].map((x, i) => {
      if (x === item) {
        this[userList].splice(i, 1);
        this._api.openSnackBar('User has been deleted', 'Error');
      }
    });
  }
  deleteUser_edit(item, userList: string) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      maxWidth: '350px'
      , data: {
        msg: 'Are you sure you want to delete this ?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const obj = {
          business_id: this.editBusinessID
          , bp_business_user_assoc_id: item.bp_business_user_assoc_id
          , um_user_id: item.um_user_id
        };
        this._api.functionPOST('business/deleteBusinessUsers', obj).subscribe((response) => {
          if (response['success']) {
            this[userList].map((x, i) => {
              if (x === item) {
                this[userList].splice(i, 1);
                this._api.openSnackBar(response['data'], 'Success');
                if (this.adminLoggedin) {
                  this.getNotifData();
                  this.getNotifDataSMS();
                }
              }
            });
          }
        });
      }
    });
  }
  IsValidate($event, form: FormGroup, field) {
    if ($event.checked) {
      if (field === 'ownership_percent') {
        form.get(field).setValidators([Validators.required, this.customValidator.validPercent]);
      } else {
        form.get(field).setValidators([Validators.required]);
      }
      form.get(field).updateValueAndValidity();
    } else {
      form.get(field).clearValidators();
      form.get(field).updateValueAndValidity();
      form.get(field).reset();
    }
  }
  openDialog(row, userList: string, i, page?: string): void {

    const popupInputData = {
      data: row
      , phone: this.phoneTypeList
      , accessType: this.accessTypeList
      , title: this.titleList
      , investor: this.investorTypeList
      , usermaintypes: this.associationList
      , oWpercent: this.oWpercent
    };
    const dialogRef = this.dialog.open(EditUserDashboardComponent, { data: JSON.stringify(popupInputData) });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        if (this[userList].length > 0) {
          if (this.hasEmailTwise(result['email'], userList)) {
            this._api.openSnackBar('This email already exist', 'Error');
            return;
          }
        }
        if (page === 'Edit') {
          const apiObj = result;
          apiObj['business_id'] = this.editBusinessID;

          this._api.functionPOST('business/updateBusinessUsers', apiObj).subscribe((response) => {
            if (response['success']) {
              this._api.openSnackBar(response['data'], 'success');
              if (result['is_contact_person'] === 'Y') {
                this[userList].map((x) => {
                  x.is_contact_person = 'N';
                });
              }
              this[userList][i] = result;
              if (this.adminLoggedin) {
                this.getNotifData();
                this.getNotifDataSMS();
              }
              this._utils.ReadMessage(true);
            }
          });
        } else {
          if (result['is_contact_person'] === 'Y') {
            this[userList].map((x) => {
              x.is_contact_person = 'N';
            });

          }
          this[userList][i] = result;

        }
      }
    });

  }
  getUserchange(result, row, dataSet) {
    let rtnResult = '';
    const array = dataSet.map((x) => {
      if (result['is_contact_person']) {
        x['is_contact_person'] = 'N';
      }
      if (x.bp_business_user_assoc_id === row.bp_business_user_assoc_id) {
        x['is_contact_person'] = (result['is_contact_person']) ? 'Y' : 'N';
        x['firstname'] = result['firstname'];
        x['middlename'] = result['middlename'];
        x['lastname'] = result['lastname'];
        x['email'] = result['email'];
        x['bp_user_title_id'] = result['bp_user_title_id'];
        x['role_id'] = result['role_id'];
        x['bp_investor_type_id'] = result['bp_investor_type_id'];
        x['bp_investor_type_comment'] = result['bp_investor_type_comment'];
        x['ownership_percent'] = result['ownership_percent'];
        rtnResult = x;
      }
      return x;
    });
    //
    return rtnResult;
  }
  updateUserList(result, row, userList: string) {
    const array = this[userList].map((x) => {
      if (result['is_contact_person']) {
        x['is_contact_person'] = 'N';
      }
      if (x === row) {
        x['is_contact_person'] = (result['is_contact_person']) ? 'Y' : 'N';
        x['firstname'] = result['firstname'];
        x['middlename'] = result['middlename'];
        x['lastname'] = result['lastname'];
        x['email'] = result['email'];
        x['bp_user_title_id'] = result['bp_user_title_id'];
        x['role_id'] = result['role_id'];
        x['bp_investor_type_id'] = result['bp_investor_type_id'];
        x['bp_investor_type_comment'] = result['bp_investor_type_comment'];
        x['ownership_percent'] = result['ownership_percent'];
      }
      return x;
    });
    //
    return array;
  }
  changeInvesterType($event, tab?) {
    this.investorTypeList.map((x) => {
      if ($event.value === x.bp_investor_type_id) {
        if (x.name === this.fieldChangeObj['Investor'] || x.name === this.fieldChangeObj['Investorvc']) {

          if (tab === 'Investor') {
            this.group = 1;
            this.investor.get('bp_investor_type_comment').setValidators([Validators.required]);
            this.investor.get('bp_investor_type_comment').updateValueAndValidity();
          }
          if (tab === 'BenOwner') {
            this.group1 = 1;
            this.BeneOwner.get('bp_investor_type_comment').setValidators([Validators.required]);
            this.BeneOwner.get('bp_investor_type_comment').updateValueAndValidity();
          }
          if (tab === 'Operator') {
            this.group2 = 1;
            this.operators.get('bp_investor_type_comment').setValidators([Validators.required]);
            this.operators.get('bp_investor_type_comment').updateValueAndValidity();
          }
          return false;
        } else {
          this.group = this.group1 = this.group2 = 0;
          this.investor.get('bp_investor_type_comment').clearValidators();
          this.investor.get('bp_investor_type_comment').updateValueAndValidity();
          this.BeneOwner.get('bp_investor_type_comment').clearValidators();
          this.BeneOwner.get('bp_investor_type_comment').updateValueAndValidity();
          this.operators.get('bp_investor_type_comment').clearValidators();
          this.operators.get('bp_investor_type_comment').updateValueAndValidity();
        }

      }
    });
  }
  changeInvesterType_edit($event, tab?) {
    this.investorTypeList.map((x) => {
      if ($event.value === x.bp_investor_type_id) {
        if (x.name === this.fieldChangeObj['Investor'] || x.name === this.fieldChangeObj['Investorvc']) {

          if (tab === 'Investor') {
            this.group_edit = 1;
            this.investor_edit.get('bp_investor_type_comment').setValidators([Validators.required]);
            this.investor_edit.get('bp_investor_type_comment').updateValueAndValidity();
          }
          if (tab === 'BenOwner') {
            this.group1_edit = 1;
            this.BeneOwner_edit.get('bp_investor_type_comment').setValidators([Validators.required]);
            this.BeneOwner_edit.get('bp_investor_type_comment').updateValueAndValidity();
          }
          if (tab === 'Operator') {
            this.group2_edit = 1;
            this.operators_edit.get('bp_investor_type_comment').setValidators([Validators.required]);
            this.operators_edit.get('bp_investor_type_comment').updateValueAndValidity();
          }
          return false;
        } else {
          this.group_edit = this.group1_edit = this.group2_edit = 0;
          this.investor_edit.get('bp_investor_type_comment').clearValidators();
          this.investor_edit.get('bp_investor_type_comment').updateValueAndValidity();
          this.BeneOwner_edit.get('bp_investor_type_comment').clearValidators();
          this.BeneOwner_edit.get('bp_investor_type_comment').updateValueAndValidity();
          this.operators_edit.get('bp_investor_type_comment').clearValidators();
          this.operators_edit.get('bp_investor_type_comment').updateValueAndValidity();
        }

      }
    });
  }
  BusinessApi() {
      // Subscribe to metrc_key changes
      this.BusinessDetailsBasic.get('metrc_key').valueChanges.subscribe(value => {
        console.log('----------------valvv', value);
        if (value) {
          // If metrc_key has a value, make metrc_state required
          this.BusinessDetailsBasic.get('metrc_state').setValidators([Validators.required]);
        } else {
          // If metrc_key is empty, clear metrc_state validators
          this.BusinessDetailsBasic.get('metrc_state').clearValidators();
        }
        this.BusinessDetailsBasic.get('metrc_state').updateValueAndValidity();
      });

     if(parseInt(this.BankDetails.value.business_bank_routing_number)<=0){
      this._api.openSnackBar('Please provide valid routing number', 'Error');
      this.goToTab(2);
      return;
     }
     if(parseInt(this.BankDetails.value['business_bank_account_number'])<=0){
      this._api.openSnackBar('Please provide valid account number', 'Error');
      this.goToTab(2);

      return;
     }

    const premisephones = this.ContactDetails.value['Preitems'].map((x) => { x['ispremise'] = 'Y'; return x; });
    const legalphones = this.ContactDetails.value['items'].map((x) => { x['ispremise'] = 'N'; return x; });
    const businessapi = {
      business_creator: this._utils.creatorID
      , name: this.BusinessDetailsBasic.value['name']
      , business_type: this.BusinessDetailsBasic.value['business_type']
      , bp_tnt_type_id: this.tntType
      , bt_region_id: this.BusinessDetailsBasic.value['metrc_state']
      , key: this.BusinessDetailsBasic.value['metrc_key']
      , nickname: this.BusinessDetailsBasic.value['nickname'] ? this.BusinessDetailsBasic.value['nickname'].trim() : this.BusinessDetailsBasic.value['nickname']
      // , parent_bp_business_id: (this.parentCompanyID) ? this.parentCompanyID : ''
      , bp_license_no: this.CannabisDetails.value['CannabisLicenceNumber'] ? this.CannabisDetails.value['CannabisLicenceNumber'].trim()
        : this.CannabisDetails.value['CannabisLicenceNumber']
      , dba: this.BusinessDetailsBasic.value['dba']
      , bp_entity_type_id: this.BusinessDetailsBasic.value['bp_entity_type']
      , bp_entity_type_comment: this.BusinessDetailsBasic.value['bp_entity_type_other']
      , bp_license_type_id: this.CannabisDetails.value['CanabusBusnessType'] ?
        this.CannabisDetails.value['CanabusBusnessType']['bp_license_type_id'] : null
      , bp_license_type_comment: this.CannabisDetails.value['CanabusBusnessTypeOther']
      , cannabistaxid: this.CannabisDetails.value['CannabisTaxID']
      , incorp_state_bt_region_id: this.BusinessDetailsBasic.value['incorp_state']
      , bp_license_no_expiration: this._utils.formatDate(this.CannabisDetails.value['ExpirationDate'], 'yyyy-mm-dd')
      , bp_license_state_bt_region_id: this.CannabisDetails.value['CannabisLicensedState']
      , fed_taxid: this.BusinessDetailsBasic.value['fed_taxid']
      // , is_cannabis_business: this.CannabisDetails.valid ? 'Y' : 'N'
      , is_cannabis_business: (this.RegType === 1) ? 'Y' : 'N'
      , is_legal_premise_addr_same: this.ContactDetails.value['is_legal_premise_addr_same'] ? 'Y' : 'N'
      , need_fin_inst_acc_assist: this.need_fin_inst_acc_assis ? 'Y' : 'N'
      , legal_address_unit: this.ContactDetails.value['Unit'] ? this.ContactDetails.value['Unit'].trim():''
      , legal_address1: this.ContactDetails.value['StreetName']
      // , legal_street_number: this.ContactDetails.value['StreetNumber']
      , legal_bt_zipcodes_id: this.ContactDetails.value['zip_id']
      , legal_bt_state: this.ContactDetails.value['State']
      , legal_bt_city: this.ContactDetails.value['City']
      , legal_bt_county: this.ContactDetails.value['County']
      , legal_bt_country: this.ContactDetails.value['CountryList']
      , legal_bt_incorrect_zip: this.ContactDetails.value['is_correct_zip_legal'] ? this.ContactDetails.value['is_correct_zip_legal'] : false
      , premise_address_unit: this.ContactDetails.value['PreUnit'] ? this.ContactDetails.value['PreUnit'].trim():''
      , premise_address1: this.ContactDetails.value['PreStreetName']
      // , premise_street_number: this.ContactDetails.value['PreStreetNumber']
      , premise_bt_zipcodes_id: this.ContactDetails.value['Prezip_id']
      , premise_bt_state: this.ContactDetails.value['PreState']
      , premise_bt_city: this.ContactDetails.value['PreCity']
      , premise_bt_county: this.ContactDetails.value['PreCounty']
      , premise_bt_country: this.ContactDetails.value['PreCountryList']
      , premise_bt_incorrect_zip: (this.ContactDetails.value['is_correct_zip_pre']) ? this.ContactDetails.value['is_correct_zip_pre'] : false
      , banks: this.BankDetailsList
      , phones: this.ContactDetails.value['is_legal_premise_addr_same'] ? [...legalphones] : [...premisephones, ...legalphones]
      , users: this.UserList
      , is_accredited: this.CannabisDetails.value['is_accredited'] ? this.CannabisDetails.value['is_accredited'] : false
      , bp_license_type_desig_comment: this.CannabisDetails.value['bp_license_type_desig_comment']
      , bp_license_type_desig_id: this.CannabisDetails.value['CanabisCategory']
      , certificate_image: this.certificatecopy
      , isbanks: this.BankDetailsList.length >= 1 ? 'Y' : 'N'
      , agreements: this.temsCheckstats
      // ,bank_account_number: this.BankDetails.value['business_bank_account_number'].toString()
      // ,routing_number: this.BankDetails.value['business_bank_routing_number'].toString()
      ,bank_account_number: this.BankDetails.value['business_bank_account_number']
      ,routing_number: this.BankDetails.value['business_bank_routing_number']
    };
    businessapi['users'].map((x) => {
      if (!x['middlename']) {
        x['middlename'] = '';
      }
    });

    this.ContactDetails.value['BusinessURL']?businessapi['web_url']=this.ContactDetails.value['BusinessURL'].toLowerCase():'';

    // if(this.BusinessDetailsBasic.get('parent_bp_business_id').value && this.BusinessDetailsBasic.get('parent_bp_business_id').value !=''){
    const type = typeof (this.BusinessDetailsBasic.get('parent_bp_business_id').value);

    if (type === 'object') {
      // if(this.BusinessDetailsBasic.get('parent_bp_business_id') !== null){
      //   if (this.BusinessDetailsBasic.get('parent_bp_business_id').value['bp_business_id'] === '') {
      //     businessapi['parent_bp_business_other_name'] = this.BusinessDetailsBasic.get('parent_bp_business_id').value['bp_business_name'];
      //   }
      // } else {
      //   businessapi['parent_bp_business_id'] = this.BusinessDetailsBasic.get('parent_bp_business_id').value['bp_business_id'];
      // }
    }
    if (type === 'string') {
      businessapi['parent_bp_business_other_name'] = this.BusinessDetailsBasic.get('parent_bp_business_id').value;
    }
    Object.keys(businessapi).forEach(key => {
      if (businessapi[key] === '') {
        delete businessapi[key];
      }
      if (businessapi[key] === null) {
        delete businessapi[key];
      }
      if (businessapi[key] === undefined) {
        delete businessapi[key];
      }
    });
    const phone_number = businessapi.phones.filter(el=> (el.phone !== '' && el.phone !== null && el.phone !== undefined))
    businessapi.phones = phone_number;

    const businessapiFormData = this._utils.changeToFromData(businessapi);


    if (this.CannabisDetails.get('is_accredited').value) {
      const expiryDate = this.CannabisDetails.value['accreditation_expiration'];
      businessapiFormData.append('file', this.certificatecopy);
      businessapiFormData.append('accreditation_expiration', Date.parse(expiryDate).toString());
      businessapiFormData.append('accreditation_standard', this.CannabisDetails.value['accreditation_standard']);
      businessapiFormData.append('accreditation_facility_id', this.CannabisDetails.value['accreditation_test_lab_id']);
      businessapiFormData.append('accreditation_certificate_no', this.CannabisDetails.value['certificate_number']);
      businessapiFormData.append('accreditation_no', this.CannabisDetails.value['accreditation_no']);
      if (this.CannabisDetails.get("isOtherStandard").value) {
        businessapiFormData.append('accredition_standard_comment', this.CannabisDetails.value['accredition_standard_comment'])

      }
    }

    this.spinner.show();
    this._api.functionPOST('business/register', businessapiFormData).subscribe((res) => {
      this.api_business_id = res['data'].business_id;
      this.spinner.hide();
      // if (this.CannabisDetails.get('is_accredited').value) {
      //   this.SendCertificate();
      // } else {
      this._api.openSnackBar(res['data'], 'success');
      this.resetAddFunctions();
      this.ContactDetails.patchValue({
        is_legal_premise_addr_same: 'Y'
      });
      this.ContactDetails_edit.patchValue({
        is_legal_premise_addr_same: 'Y'
      });
      // }
    },
      err => {
        this._api.openSnackBar(err['error'], 'Error');
      });
  }
  // SendCertificate() {
  //   const formdata = new FormData();
  //   formdata.append('certificate_image', this.certificatecopy);
  //   formdata.append('business_id', this.api_business_id);
  //   this._api.functionPOST('business/certificate_image', formdata).subscribe((res) => {
  //     this.resetAddFunctions();
  //     this._api.openSnackBar('Business Details Added Successfully', 'success');
  //   },
  //     err => {
  //       this._api.openSnackBar(err['error'], 'Error');
  //     });
  // }

  resetAddFunctions() {
    this.selectedIndex = 0;
    this.getBusinessList();
    this.goToTab(0);
    this.RegBlock = true;
    this.resetForm_Add();
    this.IsAcreditedLab(false, this.CannabisDetails);
    this.getUserInit('UserList');
  }

  passCertificate($event, type) {

    if (!this.validateFile($event)) {
      type === 'Add' ? this.attachInputRef.nativeElement.value = '' : this.attachInputRefEdit.nativeElement.value = '';
      return false;
    }

    if (type === 'Edit') {
      this.EditCertificatecopy = $event.target.files[0];
      this.CannabisDetails_edit.patchValue({
        certificate_image: $event.target['files'][0].name,
      });
    } else {
      this.certificatecopy = $event.target.files[0];
      this.CannabisDetails.patchValue({
        certificate_image: $event.target['files'][0].name,
      });
    }
  }

  validateFile(filedata) {
    const file = filedata.target.files[0];
    let isSupported = true;
    if (file) {
      const extn = file.name.split('.').pop();
      if (this.supportedDocType.includes(extn.toLowerCase())) {
        if (file.size > this.supportedFile['fileSize']) {
          this._api.openSnackBar('Size should be less than ' + this.supportedFile['maxSize'], 'Error');
          isSupported = false;

        }
      } else {
        this._api.openSnackBar('File not supported', 'Error');
        isSupported = false;

      }
    }

    return isSupported;
  }

  getSupportedFiles() {
    this._utils.supportedUploadTypesData.subscribe(res => {
      if (res) {
        const files = res['supported_file_types'];
        this.supportedDocType = files.split(',');
      }
      var size = (res['max_file_size_bytes'] / 1000000) + ' MB';
      this.supportedFile = {
        maxSize: size,
        fileSize: res['max_file_size_bytes'],
        type: res['supported_file_types']
      };
      this.supportMaxFileSize = '* Supported maximum file size is ' + this.supportedFile['maxSize'];
      this.instructionString = this.instructionString = '* Supported document types are '
        + this.supportedFile['type'] + '\n' + '* Supported maximum file size is ' + this.supportedFile['maxSize'];

    }
    );
  }
  openBusRegModel(): void {
    const dialogRef = this.dialog.open(RegisterBusinessModelDashboradComponent, { width: '350px', disableClose: true, data: '' });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.Nick_name = result.nickName;
        this.parent_bp_business_id = result.parentCompany;
        this.BusinessApi();
      }
    });

  }
  goToClone(cloneID, Type: number) {
    this.selectedIndex = 1;
    this.initForms();
    this.cloneBusiness(cloneID, Type);
  }
  cloneBusiness(cloneID, Type: number) {

    this.spinner.show();
    this.resetForm_Add();
    this.RegBlock = false;
    this._api.functionPOST('business/cloneBusiness', { business_id: cloneID }).subscribe((response) => {
      const data = response['data'];
      this.RegType = Type;
      this.getCannabisCountryList(data.busiData['bp_license_state_bt_country_id']);
      this.titleNo.CannabisRelatedDetails.enabled = Type === 1;
      this.getTitleNo();
      this.need_fin_inst_acc_assis_edit = (data['busiData']['need_fin_inst_acc_assist'] === 'Y') ? true : false;
      const dataObj = {
        dataset: data
        , basicDetails: this.BusinessDetailsBasic
        , cannabisDetails: this.CannabisDetails
        , contactDetails: this.ContactDetails
        , bankingtList: 'BankDetailsList'
        , userList: 'UserList'
        , bankDetails: this.BankDetails
        , lab: 'Lab'
        , entityOther: 'other_entity'
        , cannabisTypeOther: 'Canabis_bus_other_type'
        , cannabisCatOther: 'OtherCanbisCategoy'
        , itemsArray: 'parentCompanyID'
        , mode: 'Clone'
      };
      this.UserList = [];
      this.populateData(dataObj);
      this.spinner.hide();
    });
  }
  populateBusiness(cloneID) {
    this.spinner.show();
    this.resetForm_edit();
    this.getDocumentMeta(cloneID, { page: 1 });
    this.getSharedWithMe(cloneID, { page: 1 });
    this.getSharingGroup(cloneID, 'new', { page: 1 });
    this.selectedIndex_inner = 1;
    this.tabvis_edit = 0;
    this.editBusinessID = cloneID;
    // this.RegBlock = false;
    this._api.functionPOST('business/cloneBusiness', { business_id: cloneID }).subscribe((response) => {
      const data = response['data'];
      const businessData = data['busiData'];
      this.getCannabisCountryList(data.busiData['bp_license_state_bt_country_id']);
      this.cloneBusinessData = data['busiData'];
      this.userDataforNotif = [...data['userData']];
      this.isAdminIn(data['userData']);
      this.totalData = response['data'];
      // this.bp_accredition_id = (businessData['bp_accredition']) ? businessData['bp_accredition']['bp_accredition_id'] : '';
      this.legal_bt_address_id = businessData['legal_bt_address_id'];
      this.premise_bt_address_id = businessData['premise_bt_address_id'];
      this.bp_business_license_id = response['data']['license_data'] ? response['data']['license_data']['bp_business_license_id'] : '';
      this.titleNoEdit.CannabisRelatedDetails.enabled = data['busiData']['is_cannabis_business'] === 'Y';
      if (data['busiData']['is_cannabis_business'] === 'Y') {
        this.RegType_edit = 1;
      } else {
        this.RegType_edit = 2;
      }
      const dataObj = {
        dataset: data
        , basicDetails: this.BusinessDetailsBasic_edit
        , cannabisDetails: this.CannabisDetails_edit
        , contactDetails: this.ContactDetails_edit
        , bankingtList: 'BankDetailsList_edit'
        , userList: 'UserList_edit'
        , bankDetails: this.BankDetails_edit
        , lab: 'Lab_edit'
        , entityOther: 'other_entity_edit'
        , cannabisTypeOther: 'Canabis_bus_other_type_edit'
        , cannabisCatOther: 'OtherCanbisCategoy_edit'
        , itemsArray: 'parentCompanyID_edit'
        , mode: 'Edit'
      };
      this.UserList_edit = [];
      this.populateData(dataObj);
      this.spinner.hide();
      this.getTitleNoEdit();
    });
    this.businessInput = { ...{ bp_business_id: cloneID } };
  }
  createBusiness(type: number) {
    this.titleNo.CannabisRelatedDetails.enabled = type === 1;
    this.RegBlock = false;
    this.RegType = type;
    this.getTitleNo();
    this.getCountryList();
    this.getUserInit('UserList');
    this.BusinessDetailsPreIncorrectZip({ checked: false }, this.ContactDetails);
    this.BusinessDetailsIncorrectZip({ checked: false }, this.ContactDetails);
  }

  populateData(Forms: {}) {
    this.BusinessDetailsPreIncorrectZip({ checked: false }, Forms['contactDetails']);
    this.BusinessDetailsIncorrectZip({ checked: false }, Forms['contactDetails']);

    const businessData = Forms['dataset']['busiData'];

    const phonesData = businessData['bp_business_phones'];
    const addressData = businessData['bt_address'];

    const preAddressData = Forms['dataset']['premise_address'];
    const zipCodeData = businessData['legal_zipcode'];
    const cannabisData = Forms['dataset']['license_data'] ? Forms['dataset']['license_data'] : {};
    this.licenseHistory = businessData['v_bp_accreditions'];
    let accreditionData = businessData['v_bp_accreditions'].find(x => x['isactive'] === 'Y');
    accreditionData = accreditionData ? accreditionData : {};

    const bankData = businessData['v_bp_business_financial_insts'];
    const userData = Forms['dataset']['userData'];

    const loggedinEmail = sessionStorage.getItem('userEmail');
    Forms['dataset']['userData'].forEach((x, i) => {
      if (x.user_email === loggedinEmail) {
        Forms['dataset']['userData'].splice(i, 1);
        Forms['dataset']['userData'].unshift(x);
      }
    });

    const zipcode = Forms['contactDetails'].get('ZipCode');
    const prezipcode = Forms['contactDetails'].get('PreZipCode');

    const mode = Forms['mode'];
    // if (businessData['parent_bp_business_id'] && businessData['parent_bp_business_id'] !== '') {
    //   this.parentCompanyList.map((x) => {
    //     if (x.bp_business_id === businessData['parent_bp_business_id']) {
    //       const event = {
    //         option: {
    //           value: {
    //             nickname: x.nickname
    //             , bp_business_id: x.bp_business_id
    //           }
    //         }
    //       };
    //       this.getNickname(event, Forms['basicDetails'], Forms['itemsArray']);
    //     }
    //   });
    // }
    this.findParentBP(businessData, Forms['basicDetails']);
    // const isPremiseNumExist = phonesData.some(x => x['ispremise'] === "Y");
    // if (!isPremiseNumExist) {
    //   phonesData.push({ ispremise: 'Y', phone: '', bt_phone_type_id: '' });
    // }

    const cannabisType = this._utils.getItemByID(this.businessLicenseList, 'bp_license_type_id', cannabisData['bp_license_type_id']);

    Forms['basicDetails'].patchValue({
      name: (mode !== 'Clone') ? businessData.name : ''
      , dba: (mode !== 'Clone') ? businessData.dba : ''
      , bp_entity_type: businessData.bp_entity_type_id
      , fed_taxid: (mode !== 'Clone') ? businessData.fed_taxid : ''
      , incorp_state: businessData.incorp_state_bt_region_id
      , bp_entity_type_other: businessData.bp_entity_type_comment
      , nickname: (mode !== 'Clone') ? businessData.nickname : ''
      // , business_type: (mode !== 'Clone') ? businessData.business_type : ''
      , business_type: businessData.business_type
      , key: businessData.key
      , bt_region_id: businessData.bt_region_id
    });
    this.changeEntityType({ value: businessData.bp_entity_type_id }, Forms['basicDetails'], Forms['entityOther']);
    Forms['contactDetails'].patchValue({
      CountryList: businessData.legal_bt_country_id
      , ZipCode: businessData.legal_zipcode
      , zip_id: businessData.legal_bt_zipcodes_id
      , State: Forms['dataset']['incorrect_legal_zipcode'] ? businessData['v_bt_address']['bt_temp_region'] : businessData.legal_bt_region_name
      , County: Forms['dataset']['incorrect_legal_zipcode'] ? businessData['v_bt_address']['bt_temp_county'] : businessData.legal_county
      , City: Forms['dataset']['incorrect_legal_zipcode'] ? businessData['v_bt_address']['bt_temp_city'] : businessData.legal_city
      // , StreetNumber: businessData.legal_street_number
      , StreetName: businessData.legal_address1
      , Unit: businessData.legal_address_unit
      , BusinessURL: businessData.web_url
      , is_legal_premise_addr_same: (businessData.is_legal_premise_addr_same === 'Y') ? true : false
      //  , is_legal_premise_addr_same: true
      , is_correct_zip_legal: Forms['dataset']['incorrect_legal_zipcode']
    });

    zipcode.clearValidators();
    zipcode.updateValueAndValidity();
    if (Forms['dataset']['incorrect_legal_zipcode']) {
      this.BusinessDetailsIncorrectZip({ checked: Forms['dataset']['incorrect_legal_zipcode'] }, Forms['contactDetails']);
    }

    if (businessData['is_cannabis_business'] === 'Y' && mode === 'Edit') {

      let d;
      let expiration_date;
      if (cannabisData['bp_license_no_expiration']) {
        d = cannabisData['bp_license_no_expiration'].split('-');
        expiration_date = new Date(d[0], parseInt(d[1]) - 1, d[2]);
      } else {
      d = '';
      expiration_date = ''
      }
    
      Forms['cannabisDetails'].patchValue({
        CanabusBusnessType: cannabisType
        , CanabisCategory: cannabisData['bp_license_type_desig_id']
        , CanabusBusnessTypeOther: cannabisData['bp_license_type_comment']
        , bp_license_type_desig_comment: cannabisData['bp_license_type_desig_comment']
        , CannabisLicensedState: cannabisData['bp_license_state_bt_region_id']
        , CannabisLicenceNumber: cannabisData['bp_license_no']
        , ExpirationDate: expiration_date
        , CannabisTaxID: businessData['cannabistaxid']
        , is_accredited: Forms['dataset']['is_accredited']
        // , bp_business_license_id : cannabisData['bp_business_license_id']
      });

      this.editMinDate = cannabisData['bp_license_no_expiration'];
      this.tempMinDate = cannabisData['bp_license_no_expiration'];
      if (Forms['dataset']['is_accredited']) {
        Forms['cannabisDetails'].patchValue({
          accreditation_expiration: accreditionData['accreditation_expiration']
          , certificate_number: accreditionData['accreditation_certificate_no']
          , accreditation_standard: accreditionData['accreditation_standard']
          , accreditation_test_lab_id: accreditionData['accreditation_facility_id']
          , certificate_image: accreditionData['attachment_name']
          , accredition_standard_comment: accreditionData['accredition_standard_comment']
          , accreditation_no: accreditionData['accreditation_no']
        });
        const lab = Forms['lab'];
        this[lab] = true;
        this.IsAcreditedLab(this[lab], Forms['cannabisDetails']);
      } else {
        this.IsAcreditedLab(false, Forms['cannabisDetails']);
      }
      this.changeStandard({ value: accreditionData['accreditation_standard'] }, Forms['cannabisDetails']);

    }
    if (mode === 'Edit') {
      this.changeCannBussType({ value: cannabisType }, Forms['cannabisDetails'], Forms['cannabisTypeOther'], Forms['lab']);
      this.IsOtherCategory({ value: businessData['bp_license_type_desig_id'] }, Forms['cannabisDetails'], Forms['cannabisCatOther']);
    }
    if (businessData.is_legal_premise_addr_same === 'N') {
      console.log('--------------business', businessData);
      Forms['contactDetails'].patchValue({
        PreCountryList: businessData.premise_bt_country_id
        , PreZipCode: businessData.premise_zipcode
        , Prezip_id: businessData.premise_bt_zipcodes_id
        , PreState: Forms['dataset']['incorrect_premise_zipcode'] ? preAddressData['bt_temp_region'] : businessData.premise_bt_region_name
        , PreCounty: Forms['dataset']['incorrect_premise_zipcode'] ? preAddressData['bt_temp_county'] : businessData.premise_county
        , PreCity: Forms['dataset']['incorrect_premise_zipcode'] ? preAddressData['bt_temp_city'] : businessData.premise_cityy
        // , PreStreetNumber: businessData.premise_street_number
        , PreStreetName: businessData.premise_address1
        , PreUnit: businessData.premise_address_unit
        , is_correct_zip_pre: Forms['dataset']['incorrect_premise_zipcode']
      });
      if (Forms['dataset']['incorrect_premise_zipcode']) {
        this.BusinessDetailsPreIncorrectZip({ checked: Forms['dataset']['incorrect_premise_zipcode'] }, Forms['contactDetails']);
      }
    }
    this.findZipBusinessDetails(Forms['contactDetails']);
    this.findZipBusinessDetailsPrem(Forms['contactDetails']);

    this.resetPhoneArray(Forms['contactDetails'], 'items');
    this.resetPhoneArray(Forms['contactDetails'], 'Preitems');
    if(businessData['bp_business_phones'].length !== 0){
      phonesData.map((x) => {
        const obj = {
          phone_type_id: x.bt_phone_type_id
          , phone: x.phone
        };
        if (x.ispremise === 'Y') {
          this.populatePhones(obj, Forms['contactDetails'], 'Preitems');
        } else {
          this.populatePhones(obj, Forms['contactDetails'], 'items');
        }
      });

    }

    this.DisableBusines_Validation(Forms['contactDetails']);
    if (mode !== 'Clone') {
      bankData.map((x) => {
        this.updateBankDetails(x, Forms['bankingtList']);
      });
    }
    userData.map((x) => {
      const userRole = [];
      x['business_user_assoc_role'].map((y) => {
        userRole.push(y.bp_user_association_id);
      });


      const Userobj = {
        email: x['user_email']
        , firstname: x['user_firstname']
        , bp_investor_type_comment: x['bp_bp_investor_type_comment']
        , bp_investor_type_id: x['bp_investor_type_id']
        , is_contact_person: x['is_contact_person']
        , lastname: x['user_lastname']
        , middlename: x['user_middlename']
        , ownership_percent: x['ownership_percent']
        , role_id: x['um_role_id']
        , type: x['bp_user_title_name']
        // , bp_user_title_id: (x['bp_user_title_name']) ? x['bp_user_title_id'] : null
        , bp_user_title_id: x['bp_user_title_id']
        , user_associations: userRole
        , um_user_id: (x['um_user_id']) ? x['um_user_id'] : ''
        , bp_business_user_assoc_id: (x['bp_business_user_assoc_id']) ? x['bp_business_user_assoc_id'] : ''
      };
      this.updateUserDetails(Userobj, Forms['userList']);
      //
    });

    // this.setAccountTypeDefault(Forms['bankDetails']);
    if(businessData['bp_business_phones'].length === 0){
      this.addItem(this.ContactDetails_edit,'items')
      this.addItem(this.ContactDetails_edit,'Preitems')
      this.addItem(this.ContactDetails,'items')
      this.addItem(this.ContactDetails,'Preitems')
    } else {
      const find = businessData['bp_business_phones'].find(el=> el.ispremise === 'Y')
      if(!find){
        this.addItem(this.ContactDetails_edit,'Preitems')
        this.addItem(this.ContactDetails,'Preitems')
      }
      const find2 = businessData['bp_business_phones'].find(el=> el.ispremise === 'N')
      if(!find2){
        this.addItem(this.ContactDetails_edit,'items')
        this.addItem(this.ContactDetails,'items')
      }
    }
  }
  resetPhoneArray(form: FormGroup, itemArray: string) {
    this[itemArray] = form.get(itemArray) as FormArray;
    while (this[itemArray].length !== 0) {
      this[itemArray].removeAt(0);
    }
  }
  populatePhones(data: {}, form: FormGroup, formArray: string): void {
    this[formArray] = form.get(formArray) as FormArray;
    this[formArray].push(this.updatePhone(data));
  }
  updateBankDetails(Data, BankingList: string) {
    const obj = {
      bp_business_financial_inst_id: Data['bp_business_financial_inst_id'],
      business_bank_name: Data['nickname'],
      business_bank_account_number: Data['account_no_display'],
      business_bank_routing_number: Data['routing_num'],
      fin_financial_inst_bp_status_name: Data['fin_financial_inst_bp_status_name']
    };
    this[BankingList].push(obj);
  }
  updateUserDetails(Data, UserList: string) {
    const obj = {
      email: Data.email
      , firstname: Data.firstname
      , bp_investor_type_comment: Data.bp_investor_type_comment
      , bp_investor_type_id: Data.bp_investor_type_id
      , is_contact_person: Data.is_contact_person
      , lastname: Data.lastname
      , middlename: Data.middlename
      , ownership_percent: Data.ownership_percent
      , role_id: Data.role_id
      , type: Data.type
      , bp_user_title_id: Data.bp_user_title_id
      , user_associations: Data.user_associations
    };
    if (Data.um_user_id && Data.bp_business_user_assoc_id) {
      obj['um_user_id'] = Data.um_user_id;
      obj['bp_business_user_assoc_id'] = Data.bp_business_user_assoc_id;
    }

    this[UserList].push(obj);
  }
  getUserInit(userList: string) {
    this[userList] = [];
    this._api.functionPOST('user/getUserDetails', {}).subscribe((res) => {
      const resAPI = res['data'];
      this[userList].push({
        firstname: resAPI.user_data.firstname
        , middlename: resAPI.user_data.middlename
        , lastname: resAPI.user_data.lastname
        , is_contact_person: 'Y'
        , email: resAPI.user_data.email
        , bp_investor_type_id: null
        , ownership_percent: 0
        , role_id: resAPI.roles.um_role_id
        , type: resAPI.user_assoc.name
        , user_associations: [resAPI.user_assoc.bp_user_association_id]
        , bp_user_title_id: null
        , is_creator: true
      });
    },

      err => {
      });
  }
  updateBasic() {

    if (!this.BusinessDetailsBasic_edit.valid) {
      this.Formvalidator.markFormGroupTouched(this.BusinessDetailsBasic_edit);

      this._api.openSnackBar('Please provide valid business details', 'Error');
      // this.goToTab(2);
      return false;
    }
    // if (!this.CannabisDetails_edit.valid && this.RegType_edit === 1) {
    //   this.Formvalidator.markFormGroupTouched(this.CannabisDetails_edit);
    //   const invalid = [];
    //   const controls = this.CannabisDetails_edit.controls;
    //   for (const name in controls) {
    //     if (controls[name].invalid) {

    //       invalid.push(name);
    //     }
    //   }
    //   if (this.CannabisDetails_edit.controls['ExpirationDate'].invalid) {
    //     const errors = this.CannabisDetails_edit.controls['ExpirationDate'].errors;
    //   }
    //   this._api.openSnackBar('Please provide valid cannabis related details', 'Error');
    //   // this.goToTab(3);
    //   return false;
    // }
    const isDuplicateLegal = this.isDuplicate(this.ContactDetails_edit.value['items']);
    const isDuplicatePremis = this.isDuplicate(this.ContactDetails_edit.value['Preitems']);
    if (isDuplicateLegal || isDuplicatePremis) {
      this._api.openSnackBar('Duplicate Phone Numbers are not Allowed', 'Error');
      // this.goToTab(4);
      return;
    }
    if (!this.ContactDetails_edit.valid) {
      this.Formvalidator.markFormGroupTouched(this.ContactDetails_edit);
      this._api.openSnackBar('Please provide valid contact details', 'Error');
      this.goToTab(1);
      return false;
    }

    this.spinner.show();
    const premisephones = this.ContactDetails_edit.value['Preitems'].map((x) => { x['ispremise'] = 'Y'; return x; });
    const legalphones = this.ContactDetails_edit.value['items'].map((x) => { x['ispremise'] = 'N'; return x; });
    const businessapi = {
      business_creator: this._utils.creatorID
      // , bp_accredition_id: (this.bp_accredition_id) ? this.bp_accredition_id : ''
      , legal_bt_address_id: this.legal_bt_address_id
      , premise_bt_address_id: (this.premise_bt_address_id) ? this.premise_bt_address_id : ''
      , business_id: this.editBusinessID
      , name: this.BusinessDetailsBasic_edit.value['name']
      , business_type: this.BusinessDetailsBasic_edit.value['business_type']
      , bp_tnt_type_id: this.tntType
      , bt_region_id: this.BusinessDetailsBasic_edit.value['metrc_state']
      , key: this.BusinessDetailsBasic_edit.value['metrc_key']
      , nickname: this.BusinessDetailsBasic_edit.value['nickname'] ? this.BusinessDetailsBasic_edit.value['nickname'].trim() : this.BusinessDetailsBasic_edit.value['nickname']
      // , parent_bp_business_id: (this.parentCompanyID_edit) ? this.parentCompanyID_edit : ''
      , bp_license_no: this.CannabisDetails_edit.value['CannabisLicenceNumber'] ? this.CannabisDetails_edit.value['CannabisLicenceNumber'].trim()
        : this.CannabisDetails_edit.value['CannabisLicenceNumber']
      , dba: this.BusinessDetailsBasic_edit.value['dba']
      , bp_entity_type_id: this.BusinessDetailsBasic_edit.value['bp_entity_type']
      , bp_entity_type_comment: this.BusinessDetailsBasic_edit.value['bp_entity_type_other']
      , bp_license_type_id: this.CannabisDetails_edit.value['CanabusBusnessType'] ?
        this.CannabisDetails_edit.value['CanabusBusnessType']['bp_license_type_id'] : null
      , bp_license_type_comment: this.CannabisDetails_edit.value['CanabusBusnessTypeOther']
      , cannabistaxid: this.CannabisDetails_edit.value['CannabisTaxID']
      , incorp_state_bt_region_id: this.BusinessDetailsBasic_edit.value['incorp_state']
      , bp_license_no_expiration: this._utils.formatDate(this.CannabisDetails_edit.value['ExpirationDate'], 'yyyy-mm-dd')
      , bp_license_state_bt_region_id: this.CannabisDetails_edit.value['CannabisLicensedState']
      , fed_taxid: this.BusinessDetailsBasic_edit.value['fed_taxid']
      // , is_cannabis_business: this.CannabisDetails_edit.valid ? 'Y' : 'N'
      , is_cannabis_business: (this.RegType_edit === 1) ? 'Y' : 'N'
      , is_legal_premise_addr_same: this.ContactDetails_edit.value['is_legal_premise_addr_same'] ? 'Y' : 'N'
      , need_fin_inst_acc_assist: this.need_fin_inst_acc_assis_edit ? 'Y' : 'N'
      , legal_address_unit: this.ContactDetails_edit.value['Unit'] ? this.ContactDetails_edit.value['Unit'].trim() : ''

      , legal_address1: this.ContactDetails_edit.value['StreetName'] ? this.ContactDetails_edit.value['StreetName'].trim() : this.ContactDetails_edit.value['StreetName']

      // , legal_street_number: this.ContactDetails_edit.value['StreetNumber'] ? this.ContactDetails_edit.value['StreetNumber'].trim() : this.ContactDetails_edit.value['StreetNumber']

      , legal_bt_zipcodes_id: this.ContactDetails_edit.value['zip_id']

      , legal_bt_state: this.ContactDetails_edit.value['State'] ? this.ContactDetails_edit.value['State'].trim() : this.ContactDetails_edit.value['State']

      , legal_bt_city: this.ContactDetails_edit.value['City'] ? this.ContactDetails_edit.value['City'].trim() : this.ContactDetails_edit.value['City']

      , legal_bt_county: this.ContactDetails_edit.value['County'] ? this.ContactDetails_edit.value['County'].trim() : this.ContactDetails_edit.value['County']
      , legal_bt_country: this.ContactDetails_edit.value['CountryList']
      , legal_bt_incorrect_zip: this.ContactDetails_edit.value['is_correct_zip_legal'] ? this.ContactDetails_edit.value['is_correct_zip_legal'] : false
      , premise_address_unit: this.ContactDetails_edit.value['PreUnit'] ? this.ContactDetails_edit.value['PreUnit'].trim() : ''
      , premise_address1: this.ContactDetails_edit.value['PreStreetName'] ?
        this.ContactDetails_edit.value['PreStreetName'].trim() : this.ContactDetails_edit.value['PreStreetName']


      // , premise_street_number: this.ContactDetails_edit.value['PreStreetNumber'] ? this.ContactDetails_edit.value['PreStreetNumber'].trim() : this.ContactDetails_edit.value['PreStreetNumber']
      , premise_bt_zipcodes_id: this.ContactDetails_edit.value['Prezip_id']
      , premise_bt_state: this.ContactDetails_edit.value['PreState'] ? this.ContactDetails_edit.value['PreState'].trim() : this.ContactDetails_edit.value['PreState']
      , premise_bt_city: this.ContactDetails_edit.value['PreCity'] ? this.ContactDetails_edit.value['PreCity'].trim() : this.ContactDetails_edit.value['PreCity']
      , premise_bt_county: this.ContactDetails_edit.value['PreCounty'] ? this.ContactDetails_edit.value['PreCounty'].trim() : this.ContactDetails_edit.value['PreCounty']
      , premise_bt_country: this.ContactDetails_edit.value['PreCountryList']
      , premise_bt_incorrect_zip: (this.ContactDetails_edit.value['is_correct_zip_pre']) ? this.ContactDetails_edit.value['is_correct_zip_pre'] : false
      // , banks: this.BankDetailsList
      , phones: this.ContactDetails_edit.value['is_legal_premise_addr_same'] ? [...legalphones] : [...premisephones, ...legalphones]
      // , users: this.UserList
      , is_accredited: this.CannabisDetails_edit.value['is_accredited'] ? this.CannabisDetails_edit.value['is_accredited'] : false
      // , accreditation_expiration: this.CannabisDetails_edit.value['accreditation_expiration']
      // , accreditation_standard: this.CannabisDetails_edit.value['accreditation_standard']
      // , accreditation_facility_id: this.CannabisDetails_edit.value['accreditation_test_lab_id']
      // , accreditation_certificate_no: this.CannabisDetails_edit.value['certificate_number']
      // , accreditation_no: this.CannabisDetails_edit.value['accreditation_no']
      // , accredition_standard_comment: this.CannabisDetails_edit.value['accredition_standard_comment']
      , bp_license_type_desig_comment: this.CannabisDetails_edit.value['bp_license_type_desig_comment']
      , bp_license_type_desig_id: this.CannabisDetails_edit.value['CanabisCategory']
      , bp_business_license_id: this.bp_business_license_id

      // , certificate_image: this.certificatecopy

      // , isbanks: this.BankDetailsList.length >= 1 ? 'Y' : 'N'
      ,
    };
    this.ContactDetails_edit.value['BusinessURL']?businessapi['web_url']=this.ContactDetails_edit.value['BusinessURL'].toLowerCase():'';
    const type = typeof (this.BusinessDetailsBasic_edit.get('parent_bp_business_id').value);
    if (type === 'object') {
      if (this.BusinessDetailsBasic_edit.get('parent_bp_business_id').value['bp_business_id'] === '') {
        businessapi['parent_bp_business_other_name'] = this.BusinessDetailsBasic_edit.get('parent_bp_business_id').value['bp_business_name'];
      } else {
        businessapi['parent_bp_business_id'] = this.BusinessDetailsBasic_edit.get('parent_bp_business_id').value['bp_business_id'];

      }
    }
    if (type === 'string') {
      businessapi['parent_bp_business_other_name'] = this.BusinessDetailsBasic_edit.get('parent_bp_business_id').value;
    }
    Object.keys(businessapi).forEach(key => {
      if (businessapi[key] === '') {
        delete businessapi[key];
      }
      if (businessapi[key] === null) {
        delete businessapi[key];
      }
      if (businessapi[key] === undefined) {
        delete businessapi[key];
      }
    });
    businessapi.phones.forEach(el=>{
      if(el.phone_type_id === '' || el.phone_type_id === null){
        delete el.phone_type_id
      }
    })
    const phone_number = businessapi.phones.filter(el=> (el.phone !== '' && el.phone !== null && el.phone !== undefined))
    businessapi.phones = phone_number;

    const businessapiFormData = this._utils.changeToFromData(businessapi);

    if (this.CannabisDetails_edit.get('is_accredited').value) {
      if (this.EditCertificatecopy) {
        businessapiFormData.append('file', this.EditCertificatecopy);
      }
      const Expiration = this.CannabisDetails_edit.value['accreditation_expiration'];
      // businessapiFormData.append('business_id', this.editBusinessID);
      businessapiFormData.append('accreditation_expiration', Date.parse(Expiration).toString());
      businessapiFormData.append('accreditation_standard', this.CannabisDetails_edit.value['accreditation_standard']);
      businessapiFormData.append('accreditation_facility_id', this.CannabisDetails_edit.value['accreditation_test_lab_id']);
      businessapiFormData.append('accreditation_certificate_no', this.CannabisDetails_edit.value['certificate_number']);
      businessapiFormData.append('accreditation_no', this.CannabisDetails_edit.value['accreditation_no']);
      if (this.CannabisDetails_edit.get('isOtherStandard').value) {
        businessapiFormData.append('accredition_standard_comment', this.CannabisDetails_edit.value['accredition_standard_comment']);
      }
    }

    this._api.functionPOST('business/updateBusinessDetails', businessapiFormData).subscribe((res) => {
      this.spinner.hide();
      this._api.openSnackBar('Business Details Updated Successfully', 'success');
      // if (this.CannabisDetails_edit.value['is_accredited']) {
      //   this.updateCertificate();

      // } else {
      this.EditCertificatecopy = null;
      this.selectedIndex_inner = 0;
      this.IsAcreditedLab(false, this.CannabisDetails_edit);
      this.getBusinessList();
      // }
    },
      err => {
        this._api.openSnackBar(err['error'], 'Error');
      });
  }

  isDuplicatePhone() {
    this.isDupPhone = false;
    const isDuplicateLegal = this.isDuplicate(this.ContactDetails.value['items']);
    const isDuplicatePremis = this.isDuplicate(this.ContactDetails.value['Preitems']);
    if (isDuplicateLegal || isDuplicatePremis) {
      this.isDupPhone = true;
    }
  }
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  validateForms() {
    this.isDupPhone = false;
    if (!this.BusinessDetailsBasic.valid) {
      this.Formvalidator.markFormGroupTouched(this.BusinessDetailsBasic);
      this._api.openSnackBar('Please provide valid business details', 'Error');
      this.goToTab(0);
      return false;
    }
    // if (!this.CannabisDetails.valid && this.RegType === 1) {
    //   this.Formvalidator.markFormGroupTouched(this.CannabisDetails);
    //   this._api.openSnackBar('Please provide valid cannabis related details', 'Error');
    //   this.goToTab(1);
    //   return false;
    // }
    const isDuplicateLegal = this.isDuplicate(this.ContactDetails.value['items']);
    const isDuplicatePremis = this.isDuplicate(this.ContactDetails.value['Preitems']);
    if (isDuplicateLegal || isDuplicatePremis) {
      this.isDupPhone = true;
      this._api.openSnackBar('Duplicate Phone Numbers are not Allowed', 'Error');
      this.goToTab(2);
      return;
    }
    if (!this.ContactDetails.valid) {
      this.Formvalidator.markFormGroupTouched(this.ContactDetails);
      this._api.openSnackBar('Please provide valid contact details', 'Error');
      this.goToTab(1);
      return false;
    }

    this.openTerms();
  }

  displayParent(parent) {
    return typeof parent === 'object' && parent? parent.bp_business_name : parent;
  }

  onCancelClone() {
    this.RegBlock = true;
    this.BusinessDetailsBasic.reset();
    this.ContactDetails.reset();
    this.ContactDetails_edit.reset();
    this.CannabisDetails.reset();
      this.backupZipDetails = {
        bt_region:'',
        county:'',
        city:''
      };
      this.ContactDetails.patchValue({
        is_legal_premise_addr_same: 'Y'
      });
  }
  getExpiry() {
    const ExpiryDate = localStorage.getItem('expiry');


    if (ExpiryDate) {
      const data = {
        expiry_message: ExpiryDate
      };
      const dialogRef = this.dialog.open(PasswordWarningComponent,
        { data });
      dialogRef.afterClosed().subscribe(result => {
        localStorage.removeItem('expiry');
        if (result) {
          this.router.navigate(['current_business/Security_Settings']);
          return false;

        }
      });
    }
  }

  isDuplicate(array: any) {
    for (let i = 0; i < array.length; i++) {
      for (let j = i + 1; j < array.length; j++) {

        if (array[i].phone !== '' &&  array[j].phone !== '') {
          if (array[i].phone === array[j].phone) {
            return true;
          }
        }
      }
    }
    return false;
  }


  updateCertificate() {
    const formdata = new FormData();
    const Expiration = this.CannabisDetails_edit.value['accreditation_expiration'];
    if (this.EditCertificatecopy) {
      formdata.append('file', this.EditCertificatecopy);
    }
    formdata.append('business_id', this.editBusinessID);
    formdata.append('accreditation_expiration', Date.parse(Expiration).toString());
    formdata.append('accreditation_standard', this.CannabisDetails_edit.value['accreditation_standard']);
    formdata.append('accreditation_facility_id', this.CannabisDetails_edit.value['accreditation_test_lab_id']);
    formdata.append('accreditation_certificate_no', this.CannabisDetails_edit.value['certificate_number']);
    formdata.append('accreditation_no', this.CannabisDetails_edit.value['accreditation_no']);
    formdata.append('accredition_standard_comment', this.CannabisDetails_edit.value['accredition_standard_comment']);
    this.spinner.show();
    this._api.functionPOST('business/updateAccredition', formdata).subscribe((res) => {
      this._api.openSnackBar('Business Details Added Successfully', 'success');
      this.EditCertificatecopy = null;
      this.selectedIndex_inner = 0;
      this.IsAcreditedLab(false, this.CannabisDetails_edit);
      this.spinner.hide();
      this.getBusinessList();
    });
  }


  openLicenseHistory() {
    const dialogRef = this.dialog.open(HistoryLabComponent, {
      data: { labData: this.licenseHistory, licenseStandards: this.accreditionstanList, business_id: this.editBusinessID }
    });
  }

  filterCalender = (d: Date): boolean => {
    const datePicker = new Date(d);
    const pickerDay = datePicker.getDate();
    const pickerMonth = datePicker.getMonth();
    const pickerYear = datePicker.getFullYear();
    return true;
  }

  streamOpened() {
    this.editMinDate = new Date();
  }
  streamClosed() {
    const selecteddate = this.CannabisDetails_edit.get('ExpirationDate').value;
    const datePicker = new Date(selecteddate);
    const pickerDay = datePicker.getDate();
    const pickerMonth = datePicker.getMonth();
    const pickerYear = datePicker.getFullYear();

    const apiDate = new Date(this.tempMinDate);
    const apiDay = apiDate.getDate();
    const apiMonth = apiDate.getMonth();
    const apiYear = apiDate.getFullYear();

    if (pickerDay === apiDay && pickerMonth === apiMonth && apiYear === pickerYear) {
      this.editMinDate = this.tempMinDate;
    }


  }


  findParentBP(businessData, form: FormGroup) {
    if (businessData['parent_bp_business_id'] && businessData['parent_bp_business_id'] !== '') {
      if (this.editBusinessID === businessData['parent_bp_business_id']) {
        form.patchValue({
          parent_bp_business_id: { bp_business_name: businessData['name'], bp_business_id: businessData['parent_bp_business_id'] }
        });
      } else {
        this.parentCompanyList.map((x) => {
          if (x.bp_business_id === businessData['parent_bp_business_id']) {
            // const event = {
            //   option: {
            //     value: {
            //       nickname: x.nickname
            //       , bp_business_id: x.bp_business_id
            //     }
            //   }
            // };
            // this.getNickname(event, Forms['basicDetails'], Forms['itemsArray']);
            form.patchValue({
              parent_bp_business_id: { bp_business_name: x.bp_business_name, bp_business_id: x.bp_business_id }
            });
          }
        });
      }
    } else {
      form.patchValue({
        parent_bp_business_id: { bp_business_name: businessData['parent_bp_business_other_name'], bp_business_id: '' }
      });
    }

  }


  getTitleNo() {
    this.titleNo.BusinessBankAccountDetails.enabled = false;
    this.titleNo.EmailNotificationConfiguration.enabled = false;
    this.titleNo.SMSNotificationConfiguration.enabled = false;
    this.titleNo.DeliveryAddress.enabled = false;
    this.titleNo.ProspectDetails.enabled = false;
    this.titleNo.SecurityDetails.enabled = false;
    this.titleNo = { ...this._utils.getTitleNo(this.titleNo) };
  }
  getTitleNoEdit() {
    // this.titleNoEdit.EmailNotificationConfiguration.enabled = false;
    // this.titleNoEdit.SMSNotificationConfiguration.enabled = false;
    this.titleNoEdit.ProspectDetails.enabled = false;
    this.titleNoEdit.SecurityDetails.enabled = false;
    this.titleNoEdit = { ...this._utils.getTitleNo(this.titleNoEdit) };
  }
  zipOnKeyPress(form: FormGroup, formctrlName, type: string) {
    form.get(formctrlName).valueChanges
      .pipe(
        debounceTime(1000)
        , distinctUntilChanged()
      )
      .subscribe((value) => {
        if (type === 'Legal') { this.findZipBusinessDetails(form); } else { this.findZipBusinessDetailsPrem(form); }
      });
  }


  resetRegForm(groupkey, tab, form: FormGroup, checkObj, type) {
    this[tab] = 0;
    this[groupkey] = 0;
    form.reset();


    if (type === 'operator') {
      this[checkObj].ControlBeneOwner = false;
      this[checkObj].ControlInvestor = false;
      this.IsValidate({ checked: false }, form, "ownership_percent");
      this.IsValidate({ checked: false }, form, "bp_investor_type_id");
      this.IsValidate({ checked: false }, form, "bp_investor_type_comment");
    }
    if (type === 'investor') {
      this[checkObj].InvestorControl = false;
      this[checkObj].InvestBeneOwner = false;
      this.IsValidate({ checked: false }, form, "bp_user_title_id");
      this.IsValidate({ checked: false }, form, "ownership_percent");
      // this.IsValidate({checked : false} ,form , "bp_investor_type_comment");

    }
    if (type === 'beneOwner') {
      this[checkObj].BeneOwnerControl = false;
      this[checkObj].BeneOwnerInvestor = false;
      this.IsValidate({ checked: false }, form, "bp_user_title_id");
      this.IsValidate({ checked: false }, form, "bp_investor_type_id");
      this.IsValidate({ checked: false }, form, "bp_investor_type_comment");

    }
  }
  isValidBusiness(
    apiData: { name?: string, nickname?: string, license?: string, bp_business_id?: string }
    , form: { formGroup: FormGroup, formControl: string, }): void {
    Object.keys(apiData).map((x) => {
      apiData[x]? apiData[x] = apiData[x].trim():'';
    });
    if (apiData.name || apiData.license || apiData.nickname) {
      this._api.functionPOST('business/checkBusiness', apiData)
        .subscribe(res => {
          if (res.data) {
            if (apiData.name) {
              form.formGroup.get(form.formControl).setErrors({ exist: 'Legal Business Name Already Exist!' });
            } else if (apiData.license) {
              form.formGroup.get(form.formControl).setErrors({ exist: 'Cannabis Business License Number Already Exist!' });
            } else if (apiData.nickname) {
              form.formGroup.get(form.formControl).setErrors({ exist: 'Business Profile Nickname Already Exist!' });
            }
          }
        });
    }
  }
  updateNeedBankAssistance($event): void {
    const apiData = {
      business_id: this.editBusinessID,
      need_fin_inst_acc_assist: $event.checked ? 'Y' : 'N'
    };
    this.spinner.show();
    this._api.functionPOST('business/updateNeedBankAssistance', apiData)
      .subscribe(res => {
        this.spinner.hide();
        this._api.openSnackBar(res.data, 'Success');
      });
  }
  folderPageChange(e) {
    this.folderPage.index = e.pageIndex;
    this.folderPage.pageSize = e.pageSize;
    this.getDocumentMeta(this.editBusinessID, { page: e.pageIndex + 1 });
  }
  sharingGroupPageChange(e) {
    this.sharingGroupfolderPage.index = e.pageIndex;
    this.sharingGroupfolderPage.pageSize = e.pageSize;
    this.getSharingGroup(this.editBusinessID, 'new', { page: e.pageIndex + 1 });
  }
  getDocumentMeta(id, page) {
    this.buId = id;
    const data = {
      bp_business_id: id,
      page: page.page,
      limit: this.folderPage.pageSize,
    }
    this.spinner.show();
    this._api.functionPOST('user/getDocumentMeta', data).subscribe((response) => {
      this.spinner.hide();
      this.newDocs = response.data;
      this.folderDocs = this.newDocs['doc_family'].rows;
      this.folderPage['limit'] = this.newDocs['doc_family']['count'] + 1;
      var data = {
        count: this.newDocs.archived.count,
        name: "Archived Documents",
        shortcode: "AD",
        bp_doc_family_id: null,
        updated_at: this.newDocs.archived.updated_at,
      }
      if (Math.ceil(this.folderPage['limit'] / this.folderPage.pageSize) <= page.page) {
        this.folderDocs.push(data);
      }
      this.folderDocs.map((x) => {
        this.DocFamily[x.shortcode] = [];
      })
      this.getDocTypes();
    })
  }
  filePageChange($event) {
    this.filePage.index = $event.pageIndex;
    this.filePage.pageSize = $event.pageSize;
    this.getAllBusinessDocsDetails(this.crumItem, { page: $event.pageIndex + 1 });
  }
  getAllBusinessDocs(event, item, page) {
    if (event.view.getSelection().type !== 'Range') {
      this.docSearchInput = '';
      this.selectionDocs.clear();
      this.pdfPreview = true;
      this.crumCode = item.shortcode;
      if (this.folderParentId == '') {
        this.crumItem = item;
        this.crumCode = item.shortcode;
        this.parentCrum = item;
      }
      if (!this.parentCrum['name']) {
        this.parentCrum = {
          'count': item.document_count,
          'name': item['v_bp_doc_type.bp_doc_family_name'],
          'shortcode': item['v_bp_doc_type.bp_doc_family_shortcode'],
          'um_user.firstname': item['um_user.firstname'],
          'um_user.lastname': item['um_user.lastname'],
          'um_user.middlename': item['um_user.middlename'],
          'um_user.um_user_id': item['um_user.um_user_id'],
        }
      }
      var data = {
        bp_business_id: this.buId,
        bp_doc_family_shortcode: this.crumCode,
        page: page.page,
        limit: this.filePage.pageSize
      }
      if (item.shortcode == 'AD') {
        delete data['bp_doc_family_shortcode'];
        data['is_archived'] = 'Y'
      }
      if (this.parentCrum['name'] == 'Archived Documents') {
        data['is_archived'] = 'Y'
      }
      if (this.docSearchInput != '') {
        if(this.docSearchInput.trim()){
          data['query'] = this.docSearchInput.trim()
        }else{
          this._api.openSnackBar('Please enter search criteria', 'Error');
          return false;
        }
      }
      if (this.folderParentId != '') {
        data['parent_bp_document_id'] = this.folderParentId
      }
      if (this.sortcolumn !== '' && this.sortcolumn) {
        data['sort_by'] = this.sortcolumn;
      }
      if (this.sortorder !== '') {
        data['sort_order'] = this.sortorder;
      }
      this.spinner.show();
      this._api.functionPOST('user/getAllBusinessDocs', data).subscribe((response) => {
        this.spinner.hide();
        this.subDocs = response.data.data;
        this.crum = response.data.breadcrumb_details;
        if (!this.displayedColumns4ListView) {
          this.subDocs.forEach((y) => {
            this.getPreviewDocDet(y);
          });
        }
        this.setSearchFalse();
      })
    }
  }

  toggleGrid() {
    this.displayedColumns4ListView = !this.displayedColumns4ListView;
    if (!this.displayedColumns4ListView) {
      this.subDocs.forEach((y) => {
        this.getPreviewDocDet(y);
      });
    }
  }
  getAllBusinessDocsDetails( item, page) {
      this.docSearchInput = '';
      this.selectionDocs.clear();
      this.pdfPreview = true;
      this.crumCode = item.shortcode;
      if (this.folderParentId == '') {
        this.crumItem = item;
        this.crumCode = item.shortcode;
        this.parentCrum = item;
      }
      if (!this.parentCrum['name']) {
        this.parentCrum = {
          'count': item.document_count,
          'name': item['v_bp_doc_type.bp_doc_family_name'],
          'shortcode': item['v_bp_doc_type.bp_doc_family_shortcode'],
          'um_user.firstname': item['um_user.firstname'],
          'um_user.lastname': item['um_user.lastname'],
          'um_user.middlename': item['um_user.middlename'],
          'um_user.um_user_id': item['um_user.um_user_id'],
        }
      }
      var data = {
        bp_business_id: this.buId,
        bp_doc_family_shortcode: this.crumCode,
        page: page.page,
        limit: this.filePage.pageSize
      }
      if (item.shortcode == 'AD') {
        delete data['bp_doc_family_shortcode'];
        data['is_archived'] = 'Y'
      }
      if (this.parentCrum['name'] == 'Archived Documents') {
        data['is_archived'] = 'Y'
      }
      if (this.docSearchInput != '') {
        if(this.docSearchInput.trim()){
          data['query'] = this.docSearchInput.trim()
        }else{
          this._api.openSnackBar('Please enter search criteria', 'Error');
          return false;
        }
      }
      if (this.folderParentId != '') {
        data['parent_bp_document_id'] = this.folderParentId
      }
      if (this.sortcolumn !== '' && this.sortcolumn) {
        data['sort_by'] = this.sortcolumn;
      }
      if (this.sortorder !== '') {
        data['sort_order'] = this.sortorder;
      }
      this.spinner.show();
      this._api.functionPOST('user/getAllBusinessDocs', data).subscribe((response) => {
        this.spinner.hide();
        this.subDocs = response.data.data;
        this.crum = response.data.breadcrumb_details;
        if (!this.displayedColumns4ListView) {
          this.subDocs.forEach((y) => {
            this.getPreviewDocDet(y);
          });
        }
        this.setSearchFalse();
      })
    }

  toggleGridSharedWithMe() {
    this.displayedColumns4ListViewSharedWithMe = !this.displayedColumns4ListViewSharedWithMe;
    if (!this.displayedColumns4ListViewSharedWithMe) {
      this.subDocsSharedWithMe.forEach((y) => {
        this.getPreviewSharedWithMe(y);
      });
    }
  }

  getPreviewDocDet(item) {
    if (item.is_folder === 'N') {
      item.docType = item.attachment_type.substr(0, item.attachment_type.indexOf('/'));
      if (item.av_overall_infected === 'N') {
        const data = {
          business_id: this.buId,
          document_id: item.bp_document_id,
        };
        this._api.fileReader('user/getBusinessDoc', data).subscribe((response) => {
          item['docUrl'] = this._utils.getImageURL(response);
        });
      }
    }
  }
  setSearchFalse() {
    this.isSearch = false;
    this.filePage.index = 0;
  }
  SearchDocuments() {
    // if (this.docSearchInput === this.prevDocSearchInput) {
    //   return ;
    // }
    this.prevDocSearchInput = this.docSearchInput;
    if (this.docSearchInput === '') {
      this.setSearchFalse();
      this.pdfPreview = false;
      if (this.crumCode === '') {
        this.getDocumentMeta(this.editBusinessID, { page: 1 });
      } else {
        this.getAllBusinessDocsDetails(this.crumItem, { page: 1 });
      }
      return;
    }
    var page = { page: 1 }
    this.selectionDocs.clear();
    this.pdfPreview = true;
    var data = {
      bp_business_id: this.buId,
      page: this.filePage.index + 1,
      limit: this.filePage.pageSize,
    }
    if (this.crumCode != '') {
      data['bp_doc_family_shortcode'] = this.crumCode
    }
    if (this.crumCode == 'AD') {
      delete data['bp_doc_family_shortcode'];
      data['is_archived'] = 'Y'
    }
    if (this.docSearchInput != '') {
      if(this.docSearchInput.trim()){
        data['query'] = this.docSearchInput.trim()
      }else{
        this._api.openSnackBar('Please enter search criteria', 'Error');
        return false;
      }
    }
    if (this.folderParentId != '') {
      data['parent_bp_document_id'] = this.folderParentId
    }
    this.spinner.show();
    this._api.functionPOST('user/getAllBusinessDocs', data).subscribe((response) => {
      this.spinner.hide();
      this.isSearch = true;
      this.filePage['limit'] = response['data']['total'];
      this.subDocs = response.data.data;
      this.crum = response.data.breadcrumb_details;
      if (!this.displayedColumns4ListView) {
        this.subDocs.forEach((y) => {
          this.getPreviewDocDet(y);
        });
      }
    })
  }
  archiveDocument(apiData) {
    const data = {
      business_id: this.buId,
      document_id: apiData
    };
    this._api.functionPOST('user/archiveBusinessDoc', data).subscribe((response) => {
      this._api.openSnackBar(response['data'], 'Success');
      var page = { page: 1 }
      this.getAllBusinessDocsDetails(this.crumItem, page);
    });
  }
  crumSwitch(i) {
    this.docSearchInput = '';
    this.setSearchFalse();
    if (i == 'Home') {
      this.pdfPreview = false;
      this.parentCrum = {};
      this.folderParentId = '';
      this.crumCode = '';
      this.getDocumentMeta(this.editBusinessID, { page: 1 });
    }
  }
  getDocTypes() {
    this._api.functionGET('user/getDocTypes').subscribe((response) => {
      this.docTypes = response['data'];
      this.docTypes.map((x) => {
        if (x.bp_doc_family_shortcode in this.DocFamily) {
          this.DocFamily[x.bp_doc_family_shortcode].push(x);
        }
      });
    },
      err => {
      });
  }
  openDialogs() {
    const selectedtype = this.crumCode;
    const dialogRef = this.dialog.open(AddNewFileComponent, {
      data: {
        // doctypes : this.docTypes ,
        doctype: this.DocFamily[selectedtype]
      }, maxWidth: '800px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.addDoc(result);
      }
    });

  }
  openFolderDialogs() {
    const selectedtype = this.crumCode;
    const dialogRef = this.dialog.open(AddNewFolderComponent, {
      data: {
        doctype: this.DocFamily[selectedtype],
        bp_business_id: this.buId
      }, maxWidth: '600px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.addFolder(result);
      }
    });
  }
  openFilesDialogs(): void {
    const selectedtype = this.crumCode;
    const dialogRef = this.dialog.open(AddMultipleDocsComponent, {
      data: {
        // doctypes : this.docTypes ,
        bp_business_id: this.buId,
        doctype: this.DocFamily[selectedtype],
        type: 'new',
        show_extra_details:true,
      }, width: '900vw'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.addMultipleFiles(result)
      }
    });
  }
  getBusinessSubDocsDetails(item) {
    if (item.is_folder == 'Y') {
      this.selectionDocs.clear();
      this.folderParentId = item.bp_document_id;
      var page = { page: 1 }
      this.getAllBusinessDocsDetails(item, page)
    }
  }

  getBusinessSubDocs(event,item) {
    if (event.view.getSelection().type !== 'Range') {
    if (item.is_folder == 'Y') {
      this.selectionDocs.clear();
      this.folderParentId = item.bp_document_id;
      var page = { page: 1 }
      this.getAllBusinessDocsDetails(item, page)
    }
  }
  }
  backTofolder(item) {
    this.folderParentId = item.path_bp_document_id;
    var page = { page: 1 };
    this.docSearchInput = '';
    this.setSearchFalse();
    this.getAllBusinessDocsDetails(item, page);
  }
  backToParent() {
    this.folderParentId = '';
    var page = { page: 1 };
    this.docSearchInput = '';
    this.setSearchFalse();
    this.getAllBusinessDocsDetails(this.parentCrum, page);
  }
  upOneFolder() {
    this.docSearchInput = '';
    this.setSearchFalse();
    if (this.crum.length == 1) {
      this.backToParent()
    } else if (this.crum.length > 1) {
      this.backTofolder(this.crum[this.crum.length - 1])
    } else {
      this.crumSwitch('Home')
    }
  }
  addDoc(apiData) {
    const data = new FormData();
    data.append('file', apiData.file);
    data.append('business_id', this.buId);
    data.append('doc_type_id', apiData.doc_type_id);
    data.append('doc_type_comment', apiData.doc_type_comment);
    data.append('doc_comment', apiData.doc_comment);
    // data.append('current_business_id', this.buId)
    data.append('is_restricted', apiData.is_restricted);
    data.append('is_folder', 'N');
    if (this.folderParentId != '') {
      data.append('parent_bp_document_id', this.folderParentId);
    }

    this.spinner.show();
    this._api.functionPOST('user/addBusinessDocs', data).subscribe((response) => {
      this.spinner.hide();
      this._api.openSnackBar('File added successfully', 'Success');
      // this.initBusinessData();
      // this.getDocdetails({ page: 1, sortTab: this.shadowDocTab });
      var page = { page: 1 };
      this.getAllBusinessDocsDetails(this.crumItem, page);
    });
  }

  addMultipleFiles(apiData) {
    const data = new FormData();
    apiData.files.map((item, index) => {
      data.append(`file[${[index]}]`, item);
    })
    data.append('business_id', this.buId);
    data.append('is_restricted', 'N');
    data.append('is_folder', 'N');
    if (this.folderParentId != '') {
      data.append('parent_bp_document_id', this.folderParentId);
    }
    let docTypeIds: any = [];
    let doc_comment: any = [];
    let is_pii: any = [];
    let is_viewable_by_admin: any = [];
    apiData.filesData.map((item) => {
      docTypeIds.push(item.doc_type_id);
      doc_comment.push(item.doc_comment);
      if (item.is_pii) {
        is_pii.push("Y")
      } else {
        is_pii.push("N")
      }
      // if (item.is_viewable_by_admin) {
      //   is_viewable_by_admin.push("Y")
      // } else {
      //   is_viewable_by_admin.push("N")
      // }
      is_viewable_by_admin.push("Y")
    })

    data.append('doc_type_id', JSON.stringify(docTypeIds));
    data.append('doc_comment', JSON.stringify(doc_comment));
    data.append('is_pii', JSON.stringify(is_pii));
    data.append('is_viewable_by_admin', JSON.stringify(is_viewable_by_admin));

    if (apiData.data.access_flag == false) {
      apiData.data.accessor_bp_business_id?data.append('accessor_bp_business_id', apiData.data.accessor_bp_business_id):'';
    } else if (apiData.data.access_flag == true) {
      data.append('access_flag', 'ALL_FIN');
    }
    this.spinner.show();
    this._api.functionPOST('user/addBusinessDocuments', data).subscribe((response) => {
      this.spinner.hide();
      this._api.openSnackBar('File added successfully', 'Success');
      var page = { page: 1 }
      this.getAllBusinessDocsDetails(this.crumItem, page);
    });
  }

  addFolder(apiData) {
    const data = new FormData();
    data.append('business_id', this.buId);
    // data.append('current_business_id', this.buId);
    data.append('is_folder', 'Y');
    data.append('is_restricted', 'N');
    data.append('folder_name', apiData.folder_name);
    data.append('bp_doc_family_shortcode', this.crumCode);
    if (apiData['access_flag'] == false) {
      if (apiData['accessor_bp_business_id']) {
        data.append('accessor_bp_business_id', apiData['accessor_bp_business_id']);
      }
    } else if (apiData['access_flag'] == true) {
      data.append('access_flag', 'ALL_FIN');
    }
    if (this.folderParentId != '') {
      data.append('parent_bp_document_id', this.folderParentId);
    }

    this.spinner.show();
    this._api.functionPOST('user/addBusinessDocuments', data).subscribe((response) => {
      this.spinner.hide();
      this._api.openSnackBar('Folder added successfully', 'Success');
      // this.getDocdetails({ page: 1, sortTab: this.shadowDocTab });
      var page = { page: 1 };
      this.getAllBusinessDocsDetails(this.crumItem, page);
    });
  }

  viewDoc(data) {
    if (data.is_folder == 'Y') {
      this.getBusinessSubDocsDetails(data)
    } else {
      if (data.av_overall_infected === 'N') {
        const _apiData = {
          business_id: this.buId,
          document_id: data.bp_document_id
        };
        this._api.fileReader('user/getBusinessDoc', _apiData).subscribe((response) => {
          this._utils.download(response);
        }, err => {
        });
      }
    }
  }
  verifyDelete(docData): void {
    const title = 'Are you sure you want to delete this ?';
    const dialogRef = this.dialog.open(DeleteVerificationComponent, {
      data: title
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteDoc(docData);
      }
    });
  }
  deleteDoc(apiData) {
    const data = {
      business_id: this.buId,
      document_id: apiData.bp_document_id
    };
    this._api.functionPOST('user/deleteBusinessDoc', data).subscribe((response) => {
      this._api.openSnackBar(response['data'], 'Success');
      // this.getDocdetails({ page: 1, sortTab: this.shadowDocTab });
      var page = { page: 1 };
      this.getAllBusinessDocsDetails(this.crumItem, page);
    });

  }

  isAllSelectedDocs() {
    const numSelected = this.selectionDocs.selected.length;
    const numRows = this.subDocs.length;
    return numSelected === numRows;
  }

  masterToggleDocs() {
    this.isAllSelectedDocs() ?
      this.selectionDocs.clear() :
      this.subDocs.forEach(row => this.selectionDocs.select(row));

    this.isAllSelectedDocs() ? this.subDocs.forEach(row => row.checkbox = true) :
      this.subDocs.forEach(row => row.checkbox = false);
  }

  downloadMultipleDocs() {
    if (this.selectionDocs.selected.length === 0) {
      this._api.openSnackBar('Please select atleast one item', 'Error');
      return false;
    }
    const documentIds = [];
    this.subDocs.map((x) => {
      if (x.checkbox) {
        documentIds.push(x['bp_document_id']);
      }
    });
    this.downLoadFileAPI(documentIds);
  }

  downLoadFileAPI(data) {
    this._api.downloadFile('user/downloadDocAttachment?ids=' + JSON.stringify(data) + '&bp_business_id=' + this.businessID, '&')
    this.selectionDocs.clear();
    this.subDocs.forEach(row => row.checkbox = false);
  }

  sortData($event) {
    this.filePage.index=0;
    this.sortcolumn = $event.active.toLowerCase();
    this.sortorder = $event.direction.toLowerCase();
    var page = { page: 1 };
    this.getAllBusinessDocsDetails(this.crumItem, page)
  }
  openShareDoc(element, i): void {
    const selectedtype = this.crumCode;
    const dialogRef = this.dialog.open(ShareDocComponent, {
      data: {
        business_id: this.cloneBusinessData['bp_business_id'],
        document_id: element.bp_document_id,
        name: element.attachment_name,
      }, width: '900px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'shareDocument') {
        this.subDocs[i]['share_count'] = (parseInt(this.subDocs[i]['share_count']) + 1).toString();
      } else if (result == 'unshareDocument') {
        if (this.subDocs[i]['share_count'] != '0') {
          this.subDocs[i]['share_count'] = (parseInt(this.subDocs[i]['share_count']) - 1).toString();
        }
      }
    });
  }

  getSharedWithMe(id, page) {
    this.spinner.show();
    let data = {
      bp_business_id: id,
      page: page.page,
      limit: this.shareWithMefolderPage.pageSize,
    }
    if (this.businessSearchInput) {
      data['query'] = this.businessSearchInput;
    }
    this._api.functionPOST('user/getSharedWithMeList', data).subscribe((response) => {
      this.spinner.hide();
      this.sharedWithMeList = response['data']['business_details']['rows'];
      this.shareWithMefolderPage.limit = response['data']['business_details']['count'];
    });
  }


  getSharingGroup(id, type, page) {
    this.spinner.show();
    let data = {
      bp_business_id: id,
      page: page.page,
      limit: this.sharingGroupfolderPage.pageSize,
    }
    if (this.groupSearchInput) {
      data['query'] = this.groupSearchInput;
    }
    this._api.functionPOST('shareGroup/getAllGroups', data).subscribe((response) => {
      this.spinner.hide();
      this.sharingGroupList = response['data']['rows'];
      this.sharingGroupfolderPage['limit'] = response['data']['total'];
      if (type == 'refresh') {
        let result = this.sharingGroupList.filter(item => item['bp_document_access_group_id'] === this.selectedBusiness['bp_document_access_group_id']);
        this.sharingGroupDetails = result[0]['bp_document_access_group_bizs'];
      }
    });
  }


  getShareWithDocsDetails(row) {
    this.docSearchInput = '';
    if (this.folderParentIdSharedWithMe == '') {
      this.crumItemSharedWithMe = row;
      // this.crumCodeSharedWithMe = row.shortcode;
      this.parentCrumSharedWithMe = row;
    }
    var data = {
      bp_business_id: this.buId
    }
    if (this.docSearchInputSharedWithMe != '') {
      data['query'] = this.docSearchInputSharedWithMe
    }

    if (this.folderParentIdSharedWithMe != '') {
      data['bp_document_id'] = this.folderParentIdSharedWithMe
    }
    this.spinner.show();
    this._api.functionPOST('user/getSharedWithMeList', data).subscribe((response) => {
      this.spinner.hide();
      this.subDocsSharedWithMe = response.data.document_details.rows;
      this.crumSharedWithMe.unshift({
        attachment_name: row.attachment_name,
        level: this.crumSharedWithMe.length + 1,
        path_bp_document_id: row.bp_document_id,
        bp_business_id: row.bp_business_id,
        isFolder: true
      });
      if (!this.displayedColumns4ListViewSharedWithMe) {
        this.subDocsSharedWithMe.forEach((y) => {
          this.getPreviewSharedWithMe(y);
        });
      }
    });
  }


  getPreviewSharedWithMe(item) {
    if (item.is_folder === 'N') {
      if (item.av_overall_infected === 'N') {
        item.docType = item.attachment_type.substr(0, item.attachment_type.indexOf('/'));
        const data = {
          business_id: item.bp_business_id,
          document_id: item.bp_document_id,
        };
        this._api.fileReader('user/getBusinessDoc', data).subscribe((response) => {
          item['docUrl'] = this._utils.getImageURL(response);
        });
      }
    }
  }


  deleteBusiness(row) {
    const title = 'Are you sure you want to delete this ?';
    const dialogRef = this.dialog.open(DeleteVerificationComponent, {
      data: title
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        let data = {
          "bp_business_id": row.bp_business_id,
          "bp_document_access_group_id": this.groupId
        }
        this._api.functionPOST('shareGroup/business/remove', data).subscribe((response) => {
          this.spinner.hide();
          this.sharingGroupDetails = this.sharingGroupDetails.filter(item => item.bp_business_id != row['bp_business_id']);
          this.getSharingGroup(this.editBusinessID, 'new', { page: 1 });
        });
      }
    });

  }


  deleteGroup(row) {
    const title = 'Are you sure you want to delete this ?';
    const dialogRef = this.dialog.open(DeleteVerificationComponent, {
      data: title
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        let data = {
          'bp_business_id': this.editBusinessID,
          'bp_document_access_group_id': row.bp_document_access_group_id
        }
        this._api.functionPOST('shareGroup/remove', data).subscribe((response) => {
          this.spinner.hide();
          this.getSharingGroup(this.editBusinessID, 'refresh', { page: 1 });
        });
      }
    });
  }

  viewBusiness(row) {
    this.selectedBusiness = row;
    this.groupId = row['bp_document_access_group_id'];
    this.sharingGroupDetails = row['bp_document_access_group_bizs'];
    this.sharingFilesIndex = 1;
  }

  addGroup(updateData?) {
    if (!updateData) {
      updateData = {
        'bp_business_id': this.editBusinessID,
        'isAdd': true
      }
    } else {
      updateData['bp_business_id'] = this.editBusinessID;
    }
    const dialogRef = this.dialog.open(SharingGroupComponent, {
      width: '500px',
      maxWidth: '600px',
      data: { updateData },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getSharingGroup(this.editBusinessID, 'new', { page: 1 });
      }
    });
  }


  addBusiness(updateData?) {
    updateData = {
      'bp_document_access_group_id': updateData.bp_document_access_group_id
    }
    const dialogRef = this.dialog.open(AddBusinessComponent, {
      width: '500px',
      maxWidth: '600px',
      data: { updateData },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getSharingGroup(this.editBusinessID, 'refresh', { page: 1 });
      }
    });
  }


  getBusinessSubDocsSharedWithMe(item) {
    if (item.is_folder == 'Y') {
      this.selectionDocsSharedWithMe.clear();
      this.folderParentIdSharedWithMe = item.bp_document_id;
      this.getShareWithDocsDetails(item)
    }
  }

  viewDocSharedWithMe(data) {
    if (data.is_folder == 'Y') {
      this.getBusinessSubDocsSharedWithMe(data);
    } else {
      if (data.av_overall_infected === 'N') {
        const _apiData = {
          business_id: data.bp_business_id,
          document_id: data.bp_document_id
        };
        this._api.fileReader('user/getBusinessDoc', _apiData).subscribe((response) => {
          this._utils.download(response);
        }, err => {

        });
      }
    }
  }

  showAllFiles() {
    this.docSearchInput = '%';
    this.SearchDocuments();
  }

  masterToggleDocsSharedWithMe() {
    this.isAllSelectedDocsSharedWithMe() ?
      this.selectionDocsSharedWithMe.clear() :
      this.subDocsSharedWithMe.forEach(row => this.selectionDocsSharedWithMe.select(row));

    this.isAllSelectedDocsSharedWithMe() ? this.subDocsSharedWithMe.forEach(row => row.checkbox = true) :
      this.subDocsSharedWithMe.forEach(row => row.checkbox = false);
  }

  isAllSelectedDocsSharedWithMe() {
    const numSelected = this.selectionDocsSharedWithMe.selected.length;
    const numRows = this.subDocsSharedWithMe.length;
    return numSelected === numRows;
  }

  crumSwitchSharedWithMe(i) {
    if (i == 'Home') {
      this.pdfPreviewSharedWithMe = false;
      this.parentCrumSharedWithMe = {};
      this.crumSharedWithMe = [];
      this.folderParentIdSharedWithMe = '';
      this.getSharedWithMe(this.editBusinessID, { page: 1 });
    }
    // this.docSearchInput = ''
  }

  upOneFolderSharedWithMe() {
    if (this.crumSharedWithMe.length == 1) {
      this.backToParentSharedWtihMe()
    } else if (this.crumSharedWithMe.length > 1) {
      this.backTofolderSharedWithMe(this.crumSharedWithMe[this.crumSharedWithMe.length - 1])
    } else {
      this.crumSwitchSharedWithMe('Home')
    }
  }


  backToParentSharedWtihMe() {
    this.folderParentIdSharedWithMe = '';
    this.crumSharedWithMe = [];
    this.docSearchInputSharedWithMe = '';
    this.getAllSharedWithMeDocs(this.parentCrumSharedWithMe, { page: 1 });
  }

  backTofolderSharedWithMe(item) {
    let index = this.crumSharedWithMe.findIndex(data => data.level == item.level);
    this.crumSharedWithMe = this.crumSharedWithMe.slice(index);
    this.folderParentIdSharedWithMe = item.path_bp_document_id;
    this.docSearchInputSharedWithMe = '';
    this.getAllSharedWithMeDocs(item, { page: 1 })
  }

  downloadMultipleDocsSharedWithMe() {
    if (this.selectionDocsSharedWithMe.selected.length === 0) {
      this._api.openSnackBar('Please select atleast one item', 'Error');
      return false;
    }
    const documentIds = [];
    this.subDocsSharedWithMe.map((x) => {
      if (x.checkbox) {
        documentIds.push(x['bp_document_id']);
      }
    });
    this.downLoadFileAPI(documentIds);
  }

  getAllSharedWithMeDocs(item, page) {
    this.selectedSharedWithMe = item;
    if (this.folderParentIdSharedWithMe == '') {
      this.crumItemSharedWithMe = item;
      item.bp_business ? this.parentCrumSharedWithMe = item.bp_business : this.parentCrumSharedWithMe = item;
    }
    this.pdfPreviewSharedWithMe = true;
    this.selectionDocsSharedWithMe.clear();
    let shared_business_id = '';
    if (item.bp_business && item.bp_business.bp_business_id) {
      shared_business_id = item.bp_business.bp_business_id;
    } else if (item.path_bp_document_id) {
      shared_business_id = item.path_bp_document_id;
    } else {
      shared_business_id = item.bp_business_id
    }
    var data = {
      bp_business_id: this.editBusinessID,
      shared_business_id: shared_business_id ? shared_business_id : '',
      page: page.page,
      limit: this.shareWithMeSubfolderPage.pageSize
    }
    if (this.docSearchInputSharedWithMe != '') {
      data['query'] = this.docSearchInputSharedWithMe
    }
    if (item.path_bp_document_id && item.isFolder) {
      delete data.shared_business_id;
      data['bp_document_id'] = item.path_bp_document_id;
    }
    this.spinner.show();
    this._api.functionPOST('user/getSharedWithMeList', data).subscribe((response) => {
      this.spinner.hide();
      this.subDocsSharedWithMe = response.data.document_details.rows;
      this.shareWithMeSubfolderPage.limit = response['data']['document_details']['count'];
      if (!this.displayedColumns4ListViewSharedWithMe) {
        this.subDocsSharedWithMe.forEach((y) => {
          this.getPreviewSharedWithMe(y);
        });
      }
    });
  }

  ngOnDestroy() {
    this.resetTabs();
  }

  resetTabs() {
    this.folderParentId = '';
    this.parentCrum = {};
    this.crumItem = '';
    this.crumItemSharedWithMe = {};
    this.parentCrumSharedWithMe = {};
    this.folderDocs = [];
    this.subDocs = [];
    this.crum = [];
    this.pdfPreview = false;
    this.sharedWithMeList = [];
    this.subDocsSharedWithMe = [];
    this.sharingGroupList = [];
    this.resetShareWithMeSubFolderPagination();
    this.sharingFilesIndex = 0;
    this.fileManagementTabs = 0;
    this.pdfPreviewSharedWithMe = false;
    this.crumSharedWithMe = [];
  }

  resetShareWithMeSubFolderPagination() {
    this.filePage = {
      pageSizeOptions: [10, 25, 50, 100]
      , limit: 25
      , pageSize: 25
      , index: 0
    };
    this.folderPage = {
      pageSizeOptions: [10, 25, 50, 100]
      , limit: 25
      , pageSize: 25
      , index: 0
    };
    this.shareWithMefolderPage = {
      pageSizeOptions: [10, 25, 50, 100]
      , limit: 25
      , pageSize: 25
      , index: 0
    };
    this.shareWithMeSubfolderPage = {
      pageSizeOptions: [10, 25, 50, 100]
      , limit: 25
      , pageSize: 25
      , index: 0
    };
    this.sharingGroupfolderPage = {
      pageSizeOptions: [10, 25, 50, 100]
      , limit: 25
      , pageSize: 25
      , index: 0
    };
  }


  copyGroup(evnt, data) {
    evnt.stopPropagation();
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (data.name));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
    this._api.openSnackBar('Text copied to clipboard', 'Success');
  }
  editDoc(data) {
    if (data.is_folder != "Y") {
      const selectedtype = this.crumCode;
      const dialogRef = this.dialog.open(EditDocComponent, {
        data: {
          data: data,
          doctype: this.DocFamily[selectedtype]
        }, maxWidth: '800px'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.editDocument(result)
        }
      });
    } else {
      const dialogRef = this.dialog.open(EditFolderComponent, {
        data: {
          data: data,
        }, maxWidth: '600px'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.editFolder(result)
        }
      });
    }

  }
  editFolder(apiData) {
    const data = {
      business_id: this.buId,
      document_id: apiData.document_id,
      folder_name: apiData.folder_name
    };
    this.spinner.show();
    this._api.functionPOST('user/editBusinessDoc', data).subscribe((response) => {
      this.spinner.hide();
      this._api.openSnackBar('File updated successfully', 'Success');
      var page = { page: 1 }
      this.getAllBusinessDocsDetails(this.crumItem, page);
    });
  }
  editDocument(apiData) {
    const data = {
      business_id: this.buId,
      attachment_name: apiData.attachment_name + "." + apiData.doc_extension,
      doc_type_id: apiData.doc_type_id,
      doc_comment: apiData.doc_comment,
      document_id: apiData.document_id
    };
    if (apiData.doc_type_comment) {
      data['doc_type_comment'] = apiData.doc_type_comment
    }
    if (apiData.is_pii) {
      data['is_pii'] = "Y"
    } else {
      data['is_pii'] = "N"
    }

    this.spinner.show();
    this._api.functionPOST('user/editBusinessDoc', data).subscribe((response) => {
      this.spinner.hide();
      this._api.openSnackBar('File updated successfully', 'Success');
      var page = { page: 1 }
      this.getAllBusinessDocsDetails(this.crumItem, page);
    });

  }
  restoreDocument(apiData) {
    const data = {
      business_id: this.buId,
      document_id: apiData
    };
    this._api.functionPOST('user/restoreBusinessDoc', data).subscribe((response) => {
      this._api.openSnackBar(response['data'], 'Success');
      var page = { page: 1 }
      this.getAllBusinessDocsDetails(this.crumItem, page);
    });
  }
  MoveMultipleDocs() {
    if (this.selectionDocs.selected.length === 0) {
      this._api.openSnackBar('Please select atleast one item', 'Error');
      return false;
    }
    const documentIds = [];
    this.subDocs.map((x) => {
      if (x.checkbox) {
        documentIds.push(x['bp_document_id']);
      }
    });
    const dialogRef = this.dialog.open(MoveDocComponent, {
      data: {
        business_id: this.buId,
        document_id: documentIds,
        name: documentIds,
        type: 'Move',
        docType: 'Move',
        id: this.businessID,
        details: this.folderDocs.filter(item => item['shortcode'] != "AD")
      }, width: '800px'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.backToParent();
    });
  }
  moveDocument(element, type) {
    const selectedtype = this.crumCode;
    const dialogRef = this.dialog.open(MoveDocComponent, {
      data: {
        business_id: this.buId,
        document_id: element,
        type: type,
        name: element.attachment_name,
        details: this.folderDocs.filter(item => item['shortcode'] != "AD")
      }, width: '800px'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.backToParent();
    });
  }
  refreshDoc() {
    if (this.crumCode === '') {
      this.crumSwitch('Home')
      this.getDocumentMeta(this.editBusinessID, { page: 1 });
    } else {
      this.getAllBusinessDocsDetails(this.crumItem, { page: 1 });
    }
  }
  openHistoryPopUp(value) {
    const data = {value:value,bizid:this.editBusinessID};
    const dialogRef = this.dialog.open(FileHistoryComponent,
      {
        minWidth: '800px',
        data:data
      });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  mainHistory(value){
    const data = {value:value,mainFolder:true,bizid:this.editBusinessID};
    const dialogRef = this.dialog.open(FileHistoryComponent,
      {
        minWidth: '800px',
        data:data
      });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  menuClick(event, i) {
    switch (event.name) {
      case 'View':
        this.viewDoc(event.details);
        break;
      case 'Edit':
        this.editDoc(event.details);
        break;
      case 'Download':
        const data = []
        data.push(event.details)
        this.downLoadFileAPI(data);
        break;
      case 'Share':
        this.openShareDoc(event.details, i);
        break;
      case 'Delete':
        this.verifyDelete(event.details);
        break;
      case 'Restore':
        this.restoreDocument(event.details);
        break;
      case 'Archive':
        this.archiveDocument(event.details);
        break;
      case 'Move':
        this.moveDocument(event.details, 'Move');
        break;
      case 'Copy':
        this.moveDocument(event.details, 'Copy');
        break;
      case 'History':
        this.openHistoryPopUp(event.details);
        break;
    }
  }
  getNotifData() {
    const data = {
      current_bp_business_id: this.editBusinessID
    };
    this.spinner.show();
    this._api.functionPOST('business/getNotificationBusinessConfig', data).subscribe((response) => {
      this.notiFTabData = response['data'];
      this.userDataforNotif = JSON.parse(JSON.stringify(this.UserList_edit));
      this.userDataforNotif.map((x) => {
        this.notifHeaders.map((y) => {
          x[y.nt_notification_cat_id] = y.is_actionable === 'N';
          if (this.notiFTabData.find((z) => {
            return z.nt_notification_cat_id === y.nt_notification_cat_id && z.um_user_id === x.um_user_id;
          })) {
            x[y.nt_notification_cat_id] = true;
          }
        });
      });
      this.spinner.hide();

    });
  }

  getNotifDataSMS() {
    const data = {
      current_bp_business_id: this.editBusinessID,
      "is_sms": "Y"
    };
    this.spinner.show();
    this._api.functionPOST('business/getNotificationBusinessConfig', data).subscribe((response) => {
      this.notiFTabDataSMS = response['data'];
      this.userDataforNotifSMS = JSON.parse(JSON.stringify(this.UserList_edit));
      this.userDataforNotifSMS.map((x) => {
        this.notifHeadersSMS.map((y) => {
          x[y.nt_notification_cat_id] = y.is_actionable === 'N';
          if (this.notiFTabDataSMS.find((z) => {
            return z.nt_notification_cat_id === y.nt_notification_cat_id && z.um_user_id === x.um_user_id;
          })) {
            x[y.nt_notification_cat_id] = true;
          }
        });
      });
      this.spinner.hide();
    });
  }
  getNotifHeader() {
    this._api.functionGET('business/getNotificationCatForBiz').subscribe((response) => {
      this.notifHeaders = this.notifHeadersSMS = response['data'];
    });
  }
  isAdminIn(data) {
    const loggedinEmail = sessionStorage.getItem('userEmail');
    this.adminLoggedin = false;
    this.advancedLoggedin = false;
    data.map((x) => {
      if (x.user_email === loggedinEmail) {
        if (x.um_role_name === 'Admin') {
          this.adminLoggedin = true;
        } else if (x.um_role_name === 'Advanced') {
          this.advancedLoggedin = true;
        }
      }
    });
    if (this.adminLoggedin) {
      this.getNotifData();
      this.getNotifDataSMS();
    }

  }
  changesecurity(type, header, userData) {
    this.spinner.show();
    let apiUrl = 'addNotificationBusinessConfig';
    const data = {
      current_bp_business_id: this.editBusinessID,
      notifications: [{
        um_user_id: userData['um_user_id'],
        nt_notification_cat_id: header['nt_notification_cat_id']
      }]
    };
    if (!type.checked) {
      apiUrl = 'deactivateNotificationBusinessConfig';
    }
    this._api.functionPOST('business/' + apiUrl, data).subscribe((response) => {
      this._api.openSnackBar(response['data'], 'success');
      this.spinner.hide();
      this.getNotifData();
    }, err => {
      this.getNotifData();
    });
  }

  changeSMSNotification(type, header, userData) {
    this.spinner.show();
    let apiUrl = 'addNotificationBusinessConfig';
    const data = {
      current_bp_business_id: this.editBusinessID,
      notifications: [{
        um_user_id: userData['um_user_id'],
        nt_notification_cat_id: header['nt_notification_cat_id'],
        "is_sms": "Y"
      }]
    };
    if (!type.checked) {
      apiUrl = 'deactivateNotificationBusinessConfig';
    }
    this._api.functionPOST('business/' + apiUrl, data).subscribe((response) => {
      this._api.openSnackBar(response['data'], 'success');
      this.spinner.hide();
      this.getNotifDataSMS();
    }, err => {
      this.getNotifDataSMS();
    });
  }

  getRetoolApp() {
    let lpu="";
    let group;
    if (this.env == "test") {
      lpu = "36c514be-b982-11ee-a77a-8fbdc6d3b155";
      group = 1932405;
 } else if (this.env == "development") {
      lpu = "18472d6e-dd8c-11ee-9700-137bf2bcb872";
      group = 1932405;
   } else if (this.env == "demo") {
      lpu = "cb8fad98-dd6d-11ee-a6b0-a7380740ec91";
      group = 1932405;
   } else if (this.env == "production") {
    lpu = "99567ab6-3b18-11ee-b6d6-8f8d3bff157d";
    group = 1932405;
   }

   const data = {
    "landingPageUuid": lpu,
      "groupIds": [group],
      "metadata": {
        rbname: this.businessIdRetool
      },
      component_name:"UniversalApp"
    }

   const Link = "integrations/generateUniversalAppEmbedURL";
   this.token = this.cookie.get('token');
   this.spinner.show();
    this._api.functionPOST(Link, data, this.token).subscribe((response) => {
      this.responseURL = response['data']['embedUrl']+"?_environment="+this.env;
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.responseURL);
      this.spinner.hide();      
    });
  }

  setBiz($event) {
    console.log('-----------------event',$event);
    this.businessIdRetool = $event.value;
    this.getRetoolApp();
    this.current_bp_business_id = $event.value;
    console.log('----------------event', $event.value);
    this.getTaskStatus();
    this.getAllTaskList({page: 1});
      this.orderFilterAttr();

  }

  getTntTypes() {
    this._api.functionGET('business/tnt/types').subscribe((res) => {
      this.tntList = res['data'];
      this.tntType = res['data'][0]['bp_tnt_type_id'];
     },
      err => {
      });
  }

  checkValidation() {
    const inputFieldValue = this.BusinessDetailsBasic.get('metrc_key')?.value;
    if (inputFieldValue) {
      this.showValidationMessage = true;
      this.BusinessDetailsBasic.get('metrc_state')?.setValidators(Validators.required);
      this.BusinessDetailsBasic.get('metrc_state')?.updateValueAndValidity();
    } else {
      this.showValidationMessage = false;
      this.BusinessDetailsBasic.get('metrc_state')?.clearValidators();
      this.BusinessDetailsBasic.get('metrc_state')?.updateValueAndValidity();
    }
  }
  
  // getCannabisCountryList() {
  //   this._api.functionGET('country/list').subscribe((res) => {
  //     this.Cannabiscountry = res['data'];
  //     this.getCannabisStates(this.Cannabiscountry[0].bt_country_id);
  //   },
  //     err => {
  //     });
  // }
  // getCannabisStates(id) {
  //   this._api.functionGET('country/cannabisStates?bt_country_id=' + id).subscribe((res) => {
  //     this.Cannabistates = res['data'];
  //   },
  //     err => {
  //     });
  // }
  

// Task Management
getKebabMenu(row) {
  const apiData = {
    bp_business_id: this.current_bp_business_id,
    tm_task_id: row['tm_task_id']
  };
  this.spinner.show();
  this._api.functionPOST('task/getAllowedTaskActions', apiData).subscribe((response) => {
    this.dynamicUserActionMenu = response['data'];
    this.spinner.hide();
  });
}
openTaskHistoryPopUp(row) {
  const data = { value: row, bizid: this.current_bp_business_id, type: 'view_history', title: 'History' };
  const dialogRef = this.dialog.open(TaskManagementComponent,
    {
      minWidth: '800px',
      data: data
    });
  dialogRef.afterClosed().subscribe(result => {
  });
}

getMenuIcon(menu: any): any {
  switch (menu.action_name) {
    case 'View':
      return {
        'disabled': !menu.allowed,
        'morerow': menu.action_name === 'View',
      };
    case 'History':
      return {
        'disabled': !menu.allowed,
        'history': menu.action_name === 'History',
      };
    default:
      return '';
  }
}
getStatusColor(status: any): any {
  // Define color based on status
  switch (status) {
    case 0:
      return '#89C2DB';
    case 10:
      return '#698dbe';
    case 20:
      return '#007bff';
    case 30:
      return '#d4ad18';
    case 40:
      return 'rgb(236, 100, 75)';
    case 50:
      return '#26a65b';
    case 60:
      return "#d0cece";
    case 70:
      return "rgb(38, 166, 91)";

  }
}
getTaskStatus() {
  this.spinner.show();
  this._api.functionGET('task/taskStatusTypes').subscribe((response) => {
    this.singleTaskStatus = response['data']['singleTaskStatus'];
    this.spinner.hide();
  });
}

changeTab(event) {
  this.selectedTaskIndex = event['index'];

}

dotMenuClicked(row, selected_menu?) {
  switch (selected_menu) {
    case 'View':
      return this.redirectToViewComponent(row);

    case 'History':
      return this.openTaskHistoryPopUp(row);
  }
}

redirectToViewComponent(row) {
  this.showChildComponent = true;
  this.taskID = row.tm_task_id;

  // const stateData = { business_id: this.current_bp_business_id };
  // localStorage.setItem('stateData', JSON.stringify(stateData));
  // this.router.navigate(['current_business/view-task-management/' + row.tm_task_id + ''], { state: { data: this.current_bp_business_id } });
}

// clearFilter(filters: string, form, page: string) {
//   this[filters] = [];
//   this[form].reset();
//   this[form].patchValue({
//     current_stage: ''
//   });
//   this.removePreset(page);
// }
removePreset(page) {
  const apiObj = {
    pref_name: page
    , pref_key: 'FILTER'
  };
  this._api.functionPOST('user/deletePreference', apiObj).subscribe((response) => {
    if (response['success']) {
      this._api.openSnackBar('Cleared Filter Successfully', 'Success');
      this.filters = [];
      this.fllterForm ? this.fllterForm['filterControls'] = [] : '';
      // this.reloadOrder({ page: 1 });
    }
  });
}

 //#region Advanced Filter API
 orderFilterAttr() {
  const apiData = {
    bp_business_id: this.current_bp_business_id,
     }
   this.spinner.show();
     this._api.functionPOST('task/getTaskFilter', apiData).subscribe((response) => {
    this.advFilterData = response['data'];
    this.spinner.hide();
  });
}

openFilterDialog(page): void {
  this.clearFilter();
  const data = {
    page: page,
    filteredData: this.fllterForm,
    filterData: this._utils.getAdvancedFilterData(this.advFilterData)};
  const dialogRef = this.dialog.open(FilterComponent,
    {
      minWidth: '800px',
      data:data
    });
  dialogRef.afterClosed().subscribe(result => {
    this.getAllTaskList({page: 1}, result['filter'])

  });
}

clearFilter(){
  this.searchinput.reset();
  this.getAllTaskList({page: 1})
}

filterValidation(tag) {
  let u_search_f = this.searchinput.get('search_field').value;
  let u_search_s = this.searchinput.get('task_status').value;

  if (!u_search_f && !u_search_s) {
    this._api.openSnackBar('Search field is empty.', 'Error');
  }

  this.getAllTaskList({ page: 1 });
}
reloadOrder(withOutPageReload?) {
  this.page = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: withOutPageReload ? this.page.pageSize : 25
    , index: 0
  };
  this.getAllTaskList({ page: 1 });
}

PageChangeUser($event) {
  this.page.pageSize = $event.pageSize;
  this.page.index = $event.pageIndex;
  this.getAllTaskList({ page: $event.pageIndex + 1 });
}
sortDataUser($event) {
  this.sortcolumn = $event.active;
  this.sortorder = $event.direction.toUpperCase();
  this.page.index = 0
  this.getAllTaskList({ page: 1 })
}

getAllTaskList(data, filter?) {

  console.log('=============================inside');
  if (!this.current_bp_business_id || this.current_bp_business_id === '') {
    // this._api.openSnackBar('Invalid business id ', 'Error');
    return;
  }
  const apiData = {
    page: data.page
    , limit: this.page.pageSize
    , bp_business_id: this.current_bp_business_id
  };

  if (this.sortcolumnTask !== '') {
    apiData['sortcolumn'] = this.sortcolumnTask;
  }
  if (this.sortorderTask !== '') {
    apiData['sortorder'] = this.sortorderTask;
  }


  if (filter) {
    apiData['filters'] = filter;
  }
  console.log('-------------apppp', apiData);
  if (this.searchinput.get('search_field').value) {
    this.searchinput.get('search_field').value.trim() ? apiData['filter'] = this.searchinput.get('search_field').value.trim() : '';
  }
  if (this.searchinput.get('task_status').value) {
    apiData['statuses'] = this.searchinput.get('task_status').value;
  }
  

  console.log('-----------------getTaskList', apiData);
  this.spinner.show();
  this._api.functionPOST('task/getExternalTaskList', apiData).subscribe((response) => {
    this.taskDetails = response['data']['data'];
    this.page['limit'] = response['data']['total'];
    this.isFiltered = response['data']['filtered'] === 'Y';
    this.spinner.hide();
  });
}

showChildComponent = false;

showChild() {
  this.showChildComponent = true;
}

showParent() {
  this.showChildComponent = false;
}

// ID verification
getIdMe() {
  // const data = {code: this.code};
  const formdata = new FormData();
  // formdata.append('code', this.code);
  //
  const data = {code: this.code};
  this._api.functionPOST('integrations/id_me/getData' , data).subscribe((response) => {
    if (response['success']) {
      this.spinner.hide();
      this._api.openSnackBar('ID.me account verified', 'success');
      this.callBack = true;
      this.getUserDetails(this.callBack);

    }

  }, err => {
    this.spinner.hide();
    this._api.openSnackBar('ID.me verification failed', 'Error');
    this.router.navigate([], { replaceUrl: true});
  });
}

openPopUP() {
  const dialogRef = this.dialog.open(VerificationPopupComponent, {
  });
}

getUserDetails(callBack?) {
  this._api.functionGET('user/getUserDetailsForEdit' ).subscribe((response) => {
    this.UserData = response.data.userData;
    this.search_input.patchValue({
      first_name : this.UserData.firstname,
      last_name : this.UserData.lastname,
      user_email : this.UserData.email
    });
  if (callBack) {
    // if (!this.UserData.kyc_pass) {
    //   this.router.navigate(['/pending_approval']);
    // } else {
       if (!this.UserData.kyc_pass) {
      this.router.navigate(['/current_business']);
    } else {
      this.router.navigate(['/dashboard/task-management']);
    }
  }
  },
  err => {

  });
}

}
